<template>
  <div>
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{ name: 'page-user-list' }" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div class="vx-col w-full flex mb-4" id="account-manage-buttons">
      <vs-button v-if="user_data && !user_data.islockedafterinventory" icon-pack="feather" type="border"
        icon="icon-edit" class="mr-4" :to="{
          name: 'app-transport-edit',
          params: { userId: $route.params.userId },
        }">Edit</vs-button>
    </div>
    <div id="user-data" v-if="user_data">
      <div class="vx-row" id="page-user-view">
        <div class="vx-col lg:w-4/12 w-full">
          <vx-card title="Transport" class="mb-base">
            <table>
              <!--<tr>
                <td class="font-semibold">Internal ID</td>
                <td>#{{ user_data.id }}</td>
              </tr>-->
              <tr>
                <td class="font-semibold">Active</td>
                <td>
                  <vs-chip v-if="user_data.isactive" color="primary">{{
                    user_data.isactive
                    }}</vs-chip>
                  <vs-chip v-else color="danger">{{
                    user_data.isactive
                    }}</vs-chip>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Transport date</td>
                <td>{{ format_date(user_data.date, false) }}</td>
              </tr>
              <tr v-if="dataTransitDate && user_data.transit_period">
                <td class="font-semibold">Delivery Date</td>
                <td>
                  {{ format_date(dataTransitDate, false) }} (Transit of
                  {{ user_data.transit_period }} days)
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Create/Update</td>
                <td>
                  {{ format_date(user_data.createdAt, true) }} /
                  {{ format_date(user_data.updatedAt, true) }}
                </td>
              </tr>
              <tr v-if="user_data.transport_tip">
                <td class="font-semibold">Type of Truck</td>
                <td>{{ user_data.transport_tip }}</td>
              </tr>
              <tr v-if="user_data.transport_remorca_type">
                <td class="font-semibold">Type of Trailer</td>
                <td>{{ user_data.transport_remorca_type }}</td>
              </tr>
              <tr v-if="user_data.transport_tonaj">
                <td class="font-semibold">Weight (t)</td>
                <td>{{ user_data.transport_tonaj }}</td>
              </tr>
              <tr v-if="user_data.transport_podea_ml">
                <td class="font-semibold">Floor length (ml)</td>
                <td>{{ user_data.transport_podea_ml }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Sumal (force)</td>
                <td>
                  <vs-chip v-if="sumalForceOrNot() === 'Mode Auto'">
                    Auto
                  </vs-chip>
                  <vs-chip color="success" v-else-if="sumalForceOrNot() === 'Force Not Mandatory'">
                    Forced "Fara Sumal"
                  </vs-chip>
                  <vs-chip color="red" v-else-if="sumalForceOrNot() === 'Force Mandatory'">
                    Forced "Cu Sumal"
                  </vs-chip>

                </td>
              </tr>

              <tr>
                <td class="font-semibold">Sumal (if Auto)</td>
                <td>

                  <vs-chip v-if="dataissumalneeded == true" color="red">{{
                    dataissumalneeded
                    }}</vs-chip>
                  <vs-chip v-else color="">{{
                    dataissumalneeded
                    }}</vs-chip>
                </td>
              </tr>
            </table>
            <GmapMap :center="center" :zoom="4" map-type-id="terrain" style="width: 100%; height: 180px" class="mt-4">
              <GmapMarker :key="index" v-for="(m, index) in markers" :position="m" :clickable="true" :draggable="false"
                @click="center = m" />
            </GmapMap>
          </vx-card>
        </div>

        <div class="vx-col lg:w-4/12 w-full">
          <vx-card v-if="user_data.people.length > 0" title="Transporter" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Name</td>
                <td v-if="user_data.people[0].iscompany">
                  <span>
                    <a href="#" @click="ViewPerson(user_data.people[0].id)">{{
                      user_data.people[0].company_name
                      }}</a>
                  </span>
                </td>
                <td v-else>
                  <span>
                    <a href="#" @click="ViewPerson(user_data.people[0].id)">{{ user_data.people[0].firstname }}
                      {{ user_data.people[0].lastname }}</a>
                  </span>
                </td>
              </tr>
              <tr v-if="user_data.people[0].iscompany">
                <td class="font-semibold">VAT</td>
                <td>{{ user_data.people[0].vat_number }}</td>
              </tr>
              <tr v-if="user_data.people[0].email">
                <td class="font-semibold">Email</td>
                <td>{{ user_data.people[0].email }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Phone</td>
                <td>{{ user_data.people[0].phone }}</td>
              </tr>
              <tr v-if="addressbilling && addressbilling.province">
                <td class="font-semibold">Address</td>
                <td>
              <tr v-if="addressbilling && addressbilling.province">
                <vs-td>
                  <u>Billing</u>
                  <p v-if="addressbilling && addressbilling.province">
                    {{ addressbilling.street }} {{ addressbilling.nr }},
                    <br />
                    {{ addressbilling.cp }} {{ addressbilling.place }} ({{
                      addressbilling.province
                    }}),
                    <br />
                    {{ addressbilling.region }},
                    {{ addressbilling.country }}
                  </p>

                  <p v-else>
                    {{ addressbilling.street }} {{ addressbilling.nr }},
                    <br />
                    {{ addressbilling.cp }} {{ addressbilling.place }} ({{
                      addressbilling.region
                    }}),
                    <br />
                    {{ addressbilling.country }}
                  </p>
                </vs-td>
              </tr>
              </td>
              </tr>
              <tr v-if="user_data.driver">
                <td class="font-semibold">Driver</td>
                <td>{{ user_data.driver }}</td>
              </tr>
              <tr v-if="user_data.driver_phone">
                <td class="font-semibold">Driver Phone</td>
                <td>{{ user_data.driver_phone }}</td>
              </tr>
              <tr v-if="user_data.truck_plate">
                <td class="font-semibold">Truck Plate</td>
                <td>{{ user_data.truck_plate }}</td>
              </tr>
              <tr v-if="user_data.trailer_plate">
                <td class="font-semibold">Trailer Plate</td>
                <td>{{ user_data.trailer_plate }}</td>
              </tr>
              <tr v-if="user_data.transport_invoice_no">
                <td class="font-semibold">Invoice No</td>
                <td>{{ user_data.transport_invoice_no }}</td>
              </tr>
              <tr v-if="user_data.transport_invoice_date">
                <td class="font-semibold">Invoice Date</td>
                <td>{{ format_date(user_data.transport_invoice_date, false) }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Transport Cost</td>
                <td>
                  {{
                    Math.abs(
                      user_data.products[0].operations_products.unit_price
                    )
                  }}
                  EUR
                </td>
              </tr>
              <tr v-if="user_data.transport_payment_method">
                <td class="font-semibold">Payment Method</td>
                <td v-if="user_data.transport_payment_method == 'direct'">
                  Payment upon receipt of documents
                </td>
                <td v-else-if="user_data.transport_payment_method == '5 days'">
                  5 days from receipt of documents
                </td>
                <td v-else-if="user_data.transport_payment_method == '10 days'">
                  10 days from receipt of documents
                </td>
                <td v-else-if="user_data.transport_payment_method == '15 days'">
                  15 days from receipt of documents
                </td>
                <td v-else>
                  30 days from receipt of documents
                </td>
              </tr>
              <tr v-if="user_data.transport_invoice_due_date">
                <td class="font-semibold">Payment Date (estimate)&nbsp;&nbsp;&nbsp;</td>
                <td>
                  {{ format_date(user_data.transport_invoice_due_date, false) }}
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Payment Status</td>
                <td v-if="user_data.salestatus &&
                  user_data.salestatus.name_en === 'Paid'
                ">
                  <vs-chip color="success">{{
                    user_data.salestatus.name_en
                    }}</vs-chip>
                </td>
                <td v-else-if="user_data.salestatus &&
                  user_data.salestatus.name_en === 'Cancelled'
                ">
                  <vs-chip color="danger">{{
                    user_data.salestatus.name_en
                    }}</vs-chip>
                </td>
                <td v-else-if="user_data.salestatus &&
                  user_data.salestatus.name_en === 'Pending'
                ">
                  <vs-chip color="warning">{{
                    user_data.salestatus.name_en
                    }}</vs-chip>
                </td>
                <td v-else>
                  <vs-chip color>{{ user_data.salestatus.name_en }}</vs-chip>
                </td>

              </tr>
            </table>
          </vx-card>
        </div>
        <div class="vx-col lg:w-4/12 w-full mb-8">
          <!--<vx-card title="Document">
            <div id="data-list-list-view">
              <vs-button
                v-if="user_data && invoiceattached && invoiceattached.length > 0 && user_data.people && user_data.people.length > 0"
                icon-pack="feather" icon="icon-file" class="mr-4 mb-4 w-full" @click="GenerateDocumentRO">Transport
                Order (Linked with
                Quotation)
              </vs-button>
              <vs-button v-else icon-pack="feather" icon="icon-file" class="mr-4 mb-4 w-full" color="danger">Transport
                Order (Missing Quotation or Transporter)
              </vs-button>

              <vs-button v-if="user_data &&
                user_data.products.length > 0 &&
                routetransport.length > 0 &&
                routetransport[0].addresses
              " icon-pack="feather" icon="icon-file" class="mr-4 mb-4 w-full" @click="GenerateDocumentCMR">CMR
              </vs-button>
              <vs-button v-else icon-pack="feather" icon="icon-file" class="mr-4 mb-4 w-full" color="danger">CMR
              </vs-button>
              <vs-button v-if="user_data &&
                user_data.products.length > 0 &&
                routetransport.length > 0 &&
                routetransport[0].addresses
              " icon-pack="feather" icon="icon-file" class="mr-4 mb-4 w-full" @click="GenerateDocumentAviz">AVIZ
                (Linked with Final Invoice)
              </vs-button>
              <vs-button v-else icon-pack="feather" icon="icon-file" class="mr-4 mb-4 w-full" color="danger">AVIZ
                (Please generate Final Invoice with address)
              </vs-button>
              <vs-button v-if="user_data &&
                user_data.products.length > 0 &&
                routetransport.length > 0 &&
                routetransport[0].addresses
              " icon-pack="feather" icon="icon-file" class="mr-4 mb-4 w-full"
                @click="GenerateDocumentReception">RECEPTION
                (Linked with Final Invoice)
              </vs-button>
              <vs-button v-else icon-pack="feather" icon="icon-file" class="mr-4 mb-4 w-full" color="danger">RECEPTION
                (Please generate Final Invoice with address)
              </vs-button>

              <vs-button v-else icon-pack="feather" icon="icon-globe" class="mr-4 mb-4 w-full" color="danger">eTransport
                (Please generate Final Invoice with address)
              </vs-button>
              <vs-table ref="table" :data="documents">
                <template slot="thead">
                  <vs-th>Document Name</vs-th>
                  <vs-th>Date of Upload</vs-th>
                  <vs-th>Action</vs-th>
                </template>
<template slot-scope="{ data }">
                  <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td style="vertical-align: middle;">{{ tr.name }}</vs-td>
                      <vs-td style="vertical-align: middle;">{{ format_date(tr.createdAt, true) }}</vs-td>
                      <vs-td style="vertical-align: middle;">
                        <div class="vx-row">
                          <vs-button class="mr-2" icon-pack="feather" icon="icon-download" type="border"
                            @click="downloadWithAxios(tr.url, tr.name)"></vs-button>
                          <vs-button icon-pack="feather" icon="icon-trash-2" color="danger" type="border"
                            @click="deleteDocumentConfirmation(tr)"></vs-button>
                        </div>
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
</vs-table>
</div>
<div class="vx-col w-full flex mt-4" id="account-manage-buttons">
  <div>
    <vs-button icon-pack="feather" icon="icon-upload" type="border" class="mr-4 sm:mb-0 mb-2"
      @click="activePrompt = true">Upload document</vs-button>
  </div>
</div>
</vx-card>-->




          <!-- ACTIVITY TIMELINE -->
          <vx-card title="Timeline">
            <!--
              Generation de la facture finale sur place : le composant ne rend
              rien, il vit le temps du telechargement puis se demonte.
            -->
            <invoice-download v-if="invoiceDownloadId" :key="invoiceDownloadId" :operation-id="invoiceDownloadId"
              embedded @done="onInvoiceDownloaded" @failed="onInvoiceDownloadFailed" />
            <vx-timeline :data="timelineData">
              <template v-slot:item="{ item }">
                <div>
                  <strong>{{ item.title }}</strong>
                  <p v-html="item.desc"></p>
                  <small>{{ item.time }}</small>
                </div>
              </template>
            </vx-timeline>
            <h4 class="mt-8 mb-4">Documents</h4>
            <!--
              Une ligne d'arret incomplete faisait planter la generation PDF sans
              aucun message (TypeError sur addresses.split). On dit desormais quel
              aviz est en cause et ou le corriger.
            -->
            <!--
              Dernier filet avant que le camion parte : la meme marchandise deux
              fois sur un meme transport. Avertissement, pas blocage - deux
              livraisons du meme produit au meme client peuvent etre legitimes.
            -->
            <vs-alert v-if="duplicateCheck && duplicateCheck.hasWarnings" :active="true" color="warning"
              icon-pack="feather" icon="icon-copy" class="mb-4">
              <p class="mb-2"><strong>Marchandise potentiellement en double sur ce transport.</strong></p>
              <ul>
                <li v-for="m in duplicateCheck.mergedOnBoard" :key="'m' + m.idquotation" class="mb-1">
                  Aviz {{ m.aviz_number }} (devis #{{ m.idquotation }}) a ete <strong>fusionne</strong>
                  dans le devis #{{ m.idmergedinto }}, qui est aussi sur ce transport (aviz
                  {{ m.aviz_number_cible }}) : ses quantites y sont deja comptees.
                </li>
                <li v-for="o in duplicateCheck.productOverlaps" :key="'p' + o.idproduct" class="mb-1">
                  <strong>{{ o.produit }}</strong> apparait sur {{ o.devis.length }} arrets du meme client
                  (devis {{ o.devis.join(', #') }} - aviz {{ o.avizs.join(', ') }}).
                </li>
              </ul>
              <p class="mt-2">Verifiez avant d'imprimer les documents : c'est ce cas qui a livre un client
                en double le 17/08.</p>
            </vs-alert>
            <!--
              Echec de chargement != donnee incomplete. Ce bandeau dit que l'API
              n'a pas repondu : sans lui, un 500 se lisait comme un PDF blanc et
              un bouton rouge accusant l'adresse de livraison.
            -->
            <vs-alert v-if="dataLoadFailed" :active="true" color="danger" icon-pack="feather"
              icon="icon-wifi-off" class="mb-4">
              <p class="mb-2"><strong>Data could not be loaded from the server - documents will be
                  blank or incomplete.</strong></p>
              <ul>
                <li v-for="err in loadErrors" :key="err.key" class="mb-1">
                  {{ err.label }} : <strong>{{ err.detail }}</strong>
                </li>
              </ul>
              <p class="mt-2">Reload the page. If it persists, this is a server-side error - send this
                message to the developer.</p>
            </vs-alert>
            <vs-alert v-if="documentsBlocked" :active="true" color="danger" icon-pack="feather"
              icon="icon-alert-triangle" class="mb-4">
              <p class="mb-2"><strong>Documents cannot be generated - incomplete delivery data.</strong></p>
              <ul>
                <li v-for="stop in incompleteStops" :key="stop.key" class="mb-1">
                  Aviz {{ stop.aviz }}: missing {{ stop.issues }}.
                  <router-link v-if="stop.link" :to="stop.link">Open {{ stop.linkLabel }} and set the delivery
                    address</router-link>
                </li>
              </ul>
            </vs-alert>
            <div id="data-list-list-view" class="mt-4 mb-2">
              <vs-button
                v-if="user_data && invoiceattached && invoiceattached.length > 0 && user_data.people && user_data.people.length > 0"
                icon-pack="feather" icon="icon-file" class="mr-4 mb-4 w-full" @click="GenerateDocumentRO">Transport
                Order (Linked with
                Quotation)
              </vs-button>
              <vs-button v-else icon-pack="feather" icon="icon-file" class="mr-4 mb-4 w-full" color="danger">Transport
                Order (Missing Quotation or Transporter)
              </vs-button>

              <!--
                Le garde ne teste plus `routetransport[0].addresses` : un transport
                dont seul le premier arret etait complet ouvrait quand meme le
                generateur, qui plantait sur l'arret suivant.
              -->
              <vs-button v-if="user_data &&
                user_data.products.length > 0 &&
                routetransport.length > 0 &&
                !documentsBlocked
              " icon-pack="feather" icon="icon-file" class="mr-4 mb-4 w-full" @click="GenerateDocumentCMR">CMR
                <!--(Linked with Final Invoice)-->
              </vs-button>
              <vs-button v-else icon-pack="feather" icon="icon-file" class="mr-4 mb-4 w-full" color="danger"
                @click="warnDocumentBlocked">CMR
                <!--(Please generate Final Invoice with address)-->
              </vs-button>
              <!--
              <vs-button v-if="user_data &&
                user_data.products.length > 0 &&
                routetransport.length > 0 &&
                routetransport[0].addresses
              " icon-pack="feather" icon="icon-file" class="mr-4 mb-4 w-full" @click="GenerateDocumentAviz">AVIZ
                (Linked with Final Invoice)
              </vs-button>
              <vs-button v-else icon-pack="feather" icon="icon-file" class="mr-4 mb-4 w-full" color="danger">AVIZ
                (Please generate Final Invoice with address)
              </vs-button>
              <vs-button v-if="user_data &&
                user_data.products.length > 0 &&
                routetransport.length > 0 &&
                routetransport[0].addresses
              " icon-pack="feather" icon="icon-file" class="mr-4 mb-4 w-full"
                @click="GenerateDocumentReception">RECEPTION
                (Linked with Final Invoice)
              </vs-button>
              <vs-button v-else icon-pack="feather" icon="icon-file" class="mr-4 mb-4 w-full" color="danger">RECEPTION
                (Please generate Final Invoice with address)
              </vs-button>
              <vs-button v-else icon-pack="feather" icon="icon-globe" class="mr-4 mb-4 w-full" color="danger">eTransport
                (Please generate Final Invoice with address)
              </vs-button>-->
              <vs-button v-if="user_data &&
                user_data.products.length > 0 &&
                routetransport.length > 0 &&
                !documentsBlocked
              " icon-pack="feather" icon="icon-file" color="success" class="mr-4 mb-4 w-full"
                @click="GenerateDocumentReceptionNew">RECEPTION NEW
                (Linked with Final Invoice)
              </vs-button>
              <vs-button v-else icon-pack="feather" icon="icon-file" class="mr-4 mb-4 w-full" color="danger"
                @click="warnDocumentBlocked">RECEPTION NEW
                ({{ documentBlockReason }})
              </vs-button>
              <vs-button v-else icon-pack="feather" icon="icon-globe" class="mr-4 mb-4 w-full" color="danger">eTransport
                ({{ documentBlockReason }})
              </vs-button>

              <vs-table ref="table" :data="documents">
                <template slot="thead">
                  <vs-th>Document Name</vs-th>
                  <vs-th>Date of Upload</vs-th>
                  <vs-th>Action</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td style="vertical-align: middle;">{{ tr.name }}</vs-td>
                      <vs-td style="vertical-align: middle;">{{ format_date(tr.createdAt, true) }}</vs-td>
                      <vs-td style="vertical-align: middle;">
                        <div class="vx-row">
                          <vs-button class="mr-2" icon-pack="feather" icon="icon-download" type="border"
                            @click="downloadWithAxios(tr.url, tr.name)"></vs-button>
                          <vs-button icon-pack="feather" icon="icon-trash-2" color="danger" type="border"
                            @click="deleteDocumentConfirmation(tr)"></vs-button>
                        </div>
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
            <div class="vx-col w-full flex mt-4" id="account-manage-buttons">
              <div>
                <vs-button icon-pack="feather" icon="icon-upload" type="border" class="mr-4 sm:mb-0 mb-2"
                  @click="activePrompt = true">Upload document</vs-button>
              </div>
            </div>
          </vx-card>

        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card title="Linked Quotation" class="mb-base">
            <template>
              <div id="data-list-list-view" class="data-list-container">
                <vs-table ref="table" :data="invoiceattached">
                  <template slot="thead">
                    <vs-th>#</vs-th>
                    <vs-th>Quotation</vs-th>
                    <vs-th>Client</vs-th>
                    <vs-th>Transport Type</vs-th>
                    <vs-th>Destination</vs-th>
                    <vs-th>Aviz Number</vs-th>
                    <vs-th>Unloading Order</vs-th>
                    <vs-th>Action</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <tbody>
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          <p class="font-medium truncate">
                            {{ indextr + 1 }}
                          </p>
                        </vs-td>

                        <vs-td>

                          <p class="font-medium truncate"><router-link :to="{
                            path: '/quotation/' + tr.id,
                          }" class="text-inherit"><u>
                                REF #{{ tr.id }}</u></router-link></p>
                        </vs-td>

                        <vs-td>
                          <p>{{ tr.people }}</p>
                        </vs-td>
                        <vs-td>
                          <p v-if="tr.tip || tr.remorca_type"><span v-if="tr.tip">{{ tr.tip }} / </span> <span
                              v-if="tr.remorca_type">{{ tr.remorca_type }}</span></p>
                          <p v-else>Not specified</p>
                        </vs-td>

                        <vs-td>
                          <p>{{ tr.place_name }} ({{ tr.postal_code }}), {{ tr.country }}</p>
                        </vs-td>

                        <vs-td>
                          <p>
                            Seria {{ tr.aviz_serie }}&nbsp;&nbsp; Nr.
                            {{ tr.aviz_number }}
                          </p>
                        </vs-td>

                        <vs-td>
                          <p>{{ tr.unloadingorder }}&nbsp;<span v-if="tr.unloadingorder == 1">(Last to be
                              loaded)</span><span v-if="invoiceattached.length == tr.unloadingorder">(First to be
                              loaded)</span></p>

                        </vs-td>
                        <vs-td class="whitespace-no-wrap"><feather-icon icon="EyeIcon"
                            svgClasses="w-5 h-5 hover:text-primary stroke-current"
                            @click="OpenOperation(tr.id)" /></vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </div>
            </template>
          </vx-card>
        </div>
      </div>

      <div v-for="ia in invoiceattached" :key="ia.id">
        <vs-alert class="mb-8" color="warning"
          :title="'Internal Note: Quotation REF #' + ia.id + ' (Client: ' + ia.people + ')'" active="true"
          v-if="ia.mail_top">
          <div v-html="'' + ia.mail_top"></div>
        </vs-alert>
      </div>
    </div>

    <!-- Deactivate button: only when no quotations linked -->
    <div class="vx-row mb-4" v-if="user_data && invoiceattached && invoiceattached.length === 0 && user_data.isactive">
      <div class="vx-col w-full">
        <vs-button color="danger" type="border" icon-pack="feather" icon="icon-x-circle" @click="confirmDeactivateTransport">
          Deactivate Transport
        </vs-button>
      </div>
    </div>

    <!-- Shared audit-log table: one implementation of the Details column,
         so a new kind of log entry renders everywhere at once. -->
    <audit-log-table ref="auditLog" entity="operation" :id="$route.params.userId" />

    <vs-prompt @cancel="clearValMultiple" @accept="acceptAlert" @close="closePrompt" :is-valid="validName"
      :active.sync="activePrompt">
      <vs-button id="file" ref="file" icon-pack="feather" icon="icon-file" class="mr-4 sm:mb-0 mb-2 w-full"
        @click="$refs.file.click()">{{ buttonUploadText }}</vs-button>
      <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" hidden />

      <div class="w-full mt-4"
        style="background-color: #ffff99;border: 1px solid #ffff99;     border-radius: 5px;        ">
        <div style="font-size: 85%">Document Name</div>
        <v-select style="background-color: #ffffff" class="w-full" autocomplete :options="select_document_type"
          v-model="dataDocumentName" />
      </div>
      <!--<vs-input
        label="Document Name"
        v-model="dataDocumentName"

        class="mt-5 w-full"
        name="document"
        v-validate="'required'"
      />
      <span class="text-danger text-sm" v-show="errors.has('url')">{{
        errors.first("url")
      }}</span>-->
    </vs-prompt>

  </div>
</template>

<script>
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import jsPDF from "jspdf";
import "jspdf-autotable";
import vSelect from "vue-select";
import moment from "moment";
import { AmiriRegular } from "@/assets/fonts/Amiri-Regular-normal.js";
import axios from "@/axios.js";
import { saveDownloadedDocument } from "@/helpers/documentDownload.js";
import AuditLogTable from "@/components/AuditLogTable.vue";
import VxTimeline from '@/components/timeline/VxTimeline.vue'

import { normalizeAddress, drawAddressBlock, fromPersonAddress, parseRouteAddress, routeStopFields } from "@/helpers/address.js";
import routeStopGuard from "@/mixins/routeStopGuard.js";
import documentDataLoad from "@/mixins/documentDataLoad.js";
// Meme composant que la page publique /download-invoice : on l'embarque pour
// generer la facture ici, plutot que d'envoyer l'utilisateur sur cette page.
import InvoiceDownload from "@/views/invoicing/InvoiceDownload.vue";
export default {
  mixins: [routeStopGuard, documentDataLoad],
  components: {
    AuditLogTable,
    vSelect,
    InvoiceDownload,
    VxTimeline
  },
  data() {
    return {
      timelineData: [{}],
      groupedProducts: [],
      duplicateCheck: null,
      dataissumalneeded: false,
      iddocumenttodelete: null,
      numberOfProductRequiresSumal: 0,
      buttonUploadText: "File Selection",
      dataTransitDate: null,
      dataDocumentName: null,
      urlDocument: null,
      user_data: null,
      user_not_found: false,
      productlist: [],
      dataOperations: [],
      documents: [],
      activePrompt: false,
      activePromptETransport: false,
      backgroundLoading: "primary",
      colorLoading: "#fff",
      isLoading: true,
      data_currency: null,
      routetransport: [],
      routetransportfromquotation: [],
      cmrproduct: [],
      allowCMR: true,
      // Facture en cours de generation via <invoice-download embedded> : le
      // composant n'existe que le temps du telechargement.
      invoiceDownloadId: null,
      invoiceDownloadTimer: null,
      addressdelivery: {},
      addressbilling: {},
      invoiceattached: null,
      markers: [],
      center: { lat: 50.0, lng: 12.0 },
      select_document_type: [
        { label: "CMR", value: "CMR" },
        { label: "INVOICE", value: "INVOICE" },
        { label: "OTHER", value: "OTHER" },
      ],
    };
  },
  computed: {
    validName() {
      if (this.dataDocumentName) return this.dataDocumentName.value;
    },
    userAddress() {
      let str = "";
      for (const field in this.user_data.address) {
        str += `${field} `;
      }
      return str;
    },
  },
  methods: {
    /**
     * Telecharge la facture finale sans quitter la page. Avant, le lien ouvrait
     * /web/download-invoice/... dans un onglet : page de marque destinee au
     * CLIENT, compte a rebours de 4 secondes, puis telechargement. Ici le clic
     * EST la demande : on monte le meme composant en mode embarque, il genere
     * le PDF et se demonte.
     */
    downloadInvoice(idinvoice) {
      if (!idinvoice) {
        this.$vs.notify({
          title: "Invoice not available",
          text: "This quotation has no final invoice yet.",
          iconPack: "feather",
          icon: "icon-alert-triangle",
          color: "warning",
          position: "top-center",
        });
        return;
      }
      // Un seul telechargement a la fois : deux clics rapides monteraient deux
      // composants qui chargeraient la meme facture en parallele.
      if (this.invoiceDownloadId) return;
      this.$vs.loading();
      // Filet : si le composant ne signale ni succes ni echec (erreur inattendue
      // hors des gardes), l'overlay plein ecran resterait affiche et bloquerait
      // la page.
      this.invoiceDownloadTimer = setTimeout(() => {
        this.onInvoiceDownloadFailed(
          "Timed out while generating invoice #" + idinvoice
        );
      }, 60000);
      this.invoiceDownloadId = idinvoice;
    },
    onInvoiceDownloaded() {
      this.stopInvoiceDownload();
    },
    stopInvoiceDownload() {
      if (this.invoiceDownloadTimer) {
        clearTimeout(this.invoiceDownloadTimer);
        this.invoiceDownloadTimer = null;
      }
      if (this.invoiceDownloadId) this.$vs.loading.close();
      this.invoiceDownloadId = null;
    },
    onInvoiceDownloadFailed(message) {
      if (!this.invoiceDownloadId) return;
      this.stopInvoiceDownload();
      this.$vs.notify({
        title: "Invoice could not be generated",
        text: message || "Unknown error",
        iconPack: "feather",
        icon: "icon-alert-triangle",
        color: "danger",
        position: "top-center",
        time: 10000,
      });
    },
    generatedTimeline() {
      /* INVOICES */
      let childTextUrl = [];
      let isinvoicegenerated = 'success'
      let icon = 'CheckIcon'
      let isuitgenerated = 'success'
      let uiticon = 'CheckIcon'
      this.invoiceattached.forEach(element => {
        if (!element.finalinvoiceno) {
          isinvoicegenerated = 'danger'
          icon = 'XIcon'
        }
        // Livraison en Roumanie = transport interne : pas de UIT eTransport a generer.
        const isinternal = this.isInternalDelivery(element)
        if (!element.uit && !isinternal) {
          isuitgenerated = 'danger'
          uiticon = 'XIcon'
        }

        childTextUrl.push({
          devis: "REF #" + element.id,
          invoice: element.finalinvoiceno,
          idinvoice: element.idfinalinvoice,
          uit: element.uit,
          internal: isinternal,
          link: '/web/quotation/' + element.id,
          linketransport: '/web/etransport/new/' + this.$route.params.userId + '/' + element.idfinalinvoice,
          // Plus de `linkinvoice` : la facture est generee sur place par
          // `downloadInvoice`. La page publique /download-invoice reste servie,
          // elle est la cible des liens cliquables des PDF de majoration deja
          // envoyes aux clients — mais l'ERP n'y renvoie plus personne.
        });
      });

      let objinv = {
        type: 'invoice',
        color: isinvoicegenerated,
        icon: icon,
        title: 'Generate Final Invoice',
        desc: childTextUrl,
      }
      this.timelineData.push(objinv)

      /* ETRANSPORT */
      // Transport 100% interne (toutes les livraisons en Roumanie) : l'etape UIT
      // n'a pas lieu d'etre, on ne l'affiche pas du tout.
      const isinternaltransport =
        childTextUrl.length > 0 && childTextUrl.every(d => d.internal)

      if (!isinternaltransport) {
        let objuit = {
          type: 'uit',
          color: isuitgenerated,
          icon: uiticon,
          title: 'Generate UIT (eTransport)',
          desc: childTextUrl,
        }
        this.timelineData.push(objuit)
      }




      let objdoc = {
        type: 'document',
        color: isuitgenerated,
        icon: uiticon,
        title: 'Print Documents',
        desc: childTextUrl,
        buttonCmr: this.GenerateDocumentCMR,
        buttonReception: this.GenerateDocumentReceptionNew,
        // Comme le CMR : le PDF est genere ici, pas sur une page intermediaire.
        buttonInvoice: this.downloadInvoice,
      }
      this.timelineData.push(objdoc)


    },
    // Un devis livre en Roumanie est un transport interne : le UIT (eTransport)
    // ne le concerne pas. Le pays vient de l'adresse de livraison du devis
    // (country_code / name_en) ; adresse manquante => on ne suppose rien.
    isInternalDelivery(element) {
      if (!element) return false;
      const code = (element.country_code || "").trim().toUpperCase();
      if (code) return code === "RO";
      const name = (element.country || "").trim().toLowerCase();
      return name === "romania" || name === "roumanie" || name === "românia";
    },
    needSumalOrNot() {
      let nsumal = 0;
      this.$store
        .dispatch("operationList/findSumalNeedForATransport", this.user_data.id)
        .then((res) => {
          nsumal = res.data.count;
          if (nsumal > 0) {
            this.dataissumalneeded = true
          } else this.dataissumalneeded = false
        });
    },
    sumalForceOrNot() {
      let forcetrue = 0;
      let forcefalse = 0;
      let auto = 0;
      this.invoiceattached.forEach(invoiceattached => {
        if (invoiceattached.sumal_mode === 'forcetrue') forcetrue++
        else if (invoiceattached.sumal_mode === 'forcefalse') forcefalse++
        else if (invoiceattached.sumal_mode === 'auto') auto++
        else auto++
      });
      let obj = [{ forcetrue: forcetrue, forcefalse: forcefalse, auto: auto }]
      if (forcetrue == 0 && forcefalse == 0) return 'Mode Auto'
      else if (forcetrue > 0) return 'Force Mandatory'
      else if (forcefalse > 0) return 'Force Not Mandatory'
      else return 'Mode Auto'
    },
    deleteDocumentConfirmation(data) {
      this.iddocumenttodelete = data.id
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete the document '${data.name}'`,
        accept: this.deleteDocument,
        acceptText: "Delete",
      });
    },
    deleteDocument() {
      let item = {
        iddocument: this.iddocumenttodelete
      };
      if (this.iddocumenttodelete !== null) {
        axios
          .post("/document/destroy", { item }, {
          })
          .then((response) => {
            this.$vs.notify({
              color: "success",
              title: "Document Deleted!",
              text: "The document was successfully deleted",
            });
            this.getDocument()
          }).catch((err) => {
            // Le notify de succes etait DANS ce catch : un 500 affichait le
            // meme message vert qu'une reussite, et le document restait la.
            console.error("document/destroy:", err);
            const data = err.response && err.response.data;
            this.$vs.notify({
              color: "danger",
              title: "Document NOT deleted",
              text: (data && (data.message || data.error)) || err.message || "The server refused the deletion.",
              time: 10000,
            });
            this.getDocument()
          })
      }
    },
    forceFileDownload(response, title, url) {
      saveDownloadedDocument(response.data, title, url);
    },
    downloadWithAxios(url, title) {
      axios({
        method: "get",
        url,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response, title, url);
        })
        .catch(() => console.log("error occured"));
    },
    acceptAlert() {
      this.$vs.loading();
      try {
        this.submitFile();
      } catch (error) { }
    },
    closePrompt() {
      this.clearValMultiple();
    },
    clearValMultiple() {
      this.dataDocumentName = "";
      this.urlDocument = "";
      this.buttonUploadText = "File Selection";
    },
    getDocument() {
      axios
        .get(`/document/${this.user_data.id}`)
        .then((response) => {
          this.documents = response.data;
        })
        .catch((error) => { });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.buttonUploadText = this.$refs.file.files[0].name;
    },
    submitFile() {
      let formData = new FormData();
      formData.append("file", this.file);
      axios
        .post("/documents/" + this.user_data.id, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          //insertdocumenttable
          let obj = {};
          obj = {
            url: response.data,
            name: this.dataDocumentName.value,
            idoperation: this.user_data.id,
          };
          axios.post("/document/create", obj).then((response) => {
            this.getDocument();
            this.$vs.loading.close();
          });
          this.$vs.notify({
            color: "success",
            title: "Document Uploaded!",
            text: "The Document was successfully Updated",
          });
        })
        .then((response) => {
          // REFRESH DOCUMENT LIST
          this.getDocument();
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    updateDeliveryDate() {
      var start = moment(this.user_data.date).add(
        this.user_data.transit_period,
        "days"
      );
      this.dataTransitDate = moment(start).toString("YYYY-MM-DD");
    },
    async getBillingAndDeliveryAddressListDetails() {
      {
        axios
          .get(
            "/person/getaddressbillingdetails/" +
            this.user_data.id +
            "/" +
            this.$route.params.userId
          )
          .then((response) => {
            if (response.data[0]) this.addressbilling = normalizeAddress(response.data[0]);
          });
      }
    },
    ViewPerson(id) {
      this.$router.push({ path: "/person/" + id });
    },
    async getCMRproduct() {
      // Deux appels dans le meme try : si le premier echoue, le second ne part
      // jamais et les DEUX listes restent vides. On le dit au lieu de laisser
      // sortir un CMR blanc.
      try {
        const response = await axios.get("/getcmrtransportv2/" + this.user_data.id);
        this.cmrproduct = response.data;
        const responsegr = await axios.get("/getcmrtransportv3/" + this.user_data.id);
        this.groupedProducts = responsegr.data;
      } catch (error) {
        this.cmrproduct = Array.isArray(this.cmrproduct) ? this.cmrproduct : [];
        this.groupedProducts = [];
        this.reportLoadError("cmrproduct", "Transported goods (CMR / reception lines)", error);
      }
    },
    // Avertissement doublons (api/app/controllers/transportcheck.controller.js).
    // Silencieux en cas d'echec : c'est un filet, pas une donnee du document.
    async getDuplicateCheck() {
      return axios
        .get("/transport/" + this.user_data.id + "/duplicatecheck")
        .then((response) => { this.duplicateCheck = response.data; })
        .catch((error) => { console.error("duplicatecheck:", error); });
    },
    async getRouteTransport() {
      // Le try/catch autour d'une promesse n'attrapait rien : sur erreur API la
      // liste restait telle quelle et les documents partaient sur des donnees
      // incompletes. On force un tableau, l'alerte fait le reste.
      return axios
        .get("/getroutetransportv2/" + this.user_data.id)
        .then((response) => {
          this.routetransport = Array.isArray(response.data) ? response.data : [];
        })
        .catch((error) => {
          this.routetransport = [];
          // Sans arret, les generateurs bouclent sur un tableau vide et sortent
          // un PDF vierge, et le garde des boutons les passe rouge avec un
          // message qui accuse l'adresse de livraison. D'ou l'alerte explicite.
          this.reportLoadError("routetransport", "Transport stops (route, addresses, aviz)", error);
        });
    },
    async getRouteTransportFromQuotation() {
      // The try/catch caught nothing: the rejection lives in the promise chain.
      return axios
        .get("/getroutetransportv3/" + this.user_data.id)
        .then((response) => {
          this.routetransportfromquotation = Array.isArray(response.data)
            ? response.data
            : [];
        })
        .catch((error) => {
          this.routetransportfromquotation = [];
          this.reportLoadError("routetransportfromquotation", "Quotation stops", error);
        });
    },
    // " (gps : lat lng)" when the address really is geocoded, "" otherwise.
    // Two traps: latitude/longitude arrive as STRINGS (Sequelize doesn't parse
    // DECIMAL) so .toFixed() throws on them, and Number(null) is 0 — printing
    // "0.00000 0.00000" for an address that simply has no coordinates.
    gpsSuffix(latitude, longitude) {
      const isBlank = (v) => v === null || v === undefined || v === "";
      if (isBlank(latitude) || isBlank(longitude)) return "";
      const lat = Number(latitude);
      const lng = Number(longitude);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return "";
      if (lat === 0 && lng === 0) return "";
      return " (gps : " + lat.toFixed(5) + " " + lng.toFixed(5) + ")";
    },
    // Carrier display name, from the operation's first linked person.
    transporterName() {
      const t = (this.user_data.people || [])[0];
      if (!t) return "";
      return (
        t.company_name ||
        [t.firstname, t.lastname].filter(Boolean).join(" ") ||
        ""
      );
    },
    OpenOperation(id) {
      this.$router.push({ path: "/quotation/" + id });
    },
    getProductListPdf() {
      axios
        .get("/getproductlistpdf/" + this.$route.params.userId + "/1")
        .then((response) => {
          this.productlist = [...response.data];
        });
    },
    // Refresh hook for the shared audit-log table (it owns its own fetch).
    getLog() {
      if (this.$refs.auditLog) this.$refs.auditLog.fetchLog();
    },
    confirmDeactivateTransport() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Deactivate Transport",
        text: "Are you sure you want to deactivate this transport? This action cannot be undone.",
        accept: this.deactivateTransport,
        acceptText: "Deactivate",
      });
    },
    deactivateTransport() {
      axios
        .post("/transport/deactivate/" + this.user_data.id, {
          who: localStorage.getItem("login-username"),
        })
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: "Transport Deactivated",
            text: "The transport has been successfully deactivated.",
          });
          this.user_data.isactive = false;
          this.getLog();
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: err.response && err.response.data ? err.response.data.message : "An error occurred.",
          });
        });
    },
    format_date(value, withhour) {
      if (value) {
        if (withhour)
          return moment(String(value)).format("DD MMM YYYY HH:mm");
        else return moment(String(value)).format("DD.MM.YYYY");
      }
    },
    moment: function () {
      return moment();
    },
    GenerateDocumentRO() {

      const doc = new jsPDF();
      doc.addFileToVFS("Amiri-Regular.ttf", AmiriRegular);
      doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
      doc.setFont("Amiri");
      doc.setFontSize(8);
      doc.setFontType("bold");
      doc.text(30, 15, "XYLO IMPACT SRL");
      doc.setFontType("normal");
      doc.text(30, 20, "RO33531190");
      doc.text(30, 25, "Strada Principala 115A");
      doc.text(30, 30, "Teiu, Comuna Lapugiu de Jos, Judet Hunedoara");
      let imgxylo = "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";
      let img_logo_acacia_bois = "data:image/jpeg;base64,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";
      doc.addImage(imgxylo, "JPEG", 130, 11, 50, 20);
      doc.setFontSize(9);
      doc.setFontType("bold");
      doc.text(72, 40, "COMANDA DE TRANSPORT NR " + this.format_date(this.user_data.createdAt, false) + "/" + this.$route.params.userId);

      // TRANSPORTATOR
      doc.text(30, 60, "Transportator:");
      doc.setFontType("normal");
      // `people` is an ARRAY: an empty one is truthy, so people[0].vat_number
      // used to throw here and kill the whole pdf.
      const transporter = (this.user_data.people || [])[0];
      if (transporter) {
        const tname = this.transporterName();
        if (transporter.vat_number) doc.text(60, 60, tname + " (TVA:" + transporter.vat_number + ")");
        else doc.text(60, 60, tname);
      }
      // FACTURARE
      doc.setFontType("bold");
      doc.text(30, 70, "Facturare:");
      doc.setFontType("normal");
      doc.text(60, 70, "XYLO IMPACT SRL");
      doc.text(60, 75, "TVA: RO33531190 - REG. COM.: J2022000979207");
      doc.text(60, 80, "Sediu Social: Strada Principala 115A, Teiu, Comuna Lapugiu de Jos, Judet Hunedoara");
      doc.text(60, 85, "IBAN: RO22 BTRL RONC RT02 6703 2501 - Banca Transilvania");
      // TIP CAMION
      doc.setFontType("bold");
      doc.text(30, 95, "Tip camion:");
      if (this.user_data.transport_remorca_type == "MEGA") doc.text(60, 95, "Preleta" + this.user_data.transport_remorca_type);
      else if (this.user_data.transport_remorca_type == "tautliner") doc.text(60, 95, "Preleta" + this.user_data.transport_remorca_type);
      else doc.text(60, 95, "-");
      doc.setFontType("normal");
      doc.text(60, 100, "Necesita 24 de chingi pentru a asigura marfa si prelata trebuie desfacuta pe ambele parti.");
      // MARFA
      doc.setFontType("bold");
      doc.text(30, 110, "Marfa:");
      doc.setFontType("normal");
      let sumalMode = this.sumalForceOrNot()
      if (sumalMode === 'Mode Auto') {
        if (this.dataissumalneeded == false)
          doc.text(60, 110, "Produse lemn salcam (fara SUMAL)");
        else doc.text(60, 110, "Produse lemn salcam (cu SUMAL)");
      }
      else if (sumalMode === 'Force Mandatory') {
        doc.text(60, 110, "Produse lemn salcam (cu SUMAL)");
      }
      else if (sumalMode === 'Force Not Mandatory') {
        doc.text(60, 110, "Produse lemn salcam (fara SUMAL)");
      }
      // MARFA
      doc.setFontType("bold");
      doc.text(30, 120, "Tonaj:");
      doc.setFontType("normal");
      if (this.user_data.transport_tip && this.user_data.transport_tonaj)
        doc.text(60, 120, this.user_data.transport_tonaj + " tone transport " + this.user_data.transport_tip.toLowerCase());
      else if (this.user_data.transport_tip) doc.text(60, 120, "24 tone transport " + this.user_data.transport_tip.toLowerCase());
      else doc.text(60, 120, "-");
      // INCARCARE
      doc.setFontType("bold");
      doc.text(30, 130, "Incarcare:");
      doc.setFontType("normal");
      doc.text(60, 130, "XYLO IMPACT, Sat Teiu, Comuna Lapugiu de Jos, Romania");
      doc.setTextColor(0, 102, 204);
      doc.textWithLink("https://goo.gl/maps/S38PWyYs7aUDsMKj8", 60, 135, { url: "https://goo.gl/maps/S38PWyYs7aUDsMKj8", });
      doc.setTextColor(0, 0, 0);
      doc.text(60, 140, "Contact incarcare: Daniela 0728 05 39 12");
      // DATE
      doc.setFontType("bold");
      doc.text(30, 150, "Data incarcarii:");
      doc.setFontType("normal");
      doc.text(60, 150, moment(this.user_data.date).format("DD.MM.YYYY"));
      // DESCARCARII
      doc.setFontType("bold");
      doc.text(30, 160, "Descarcarii: ");
      doc.setFontType("normal");
      // Baseline of the block, so an empty list can't make everything below
      // (Observatii, Pret negociat, signature) draw on top of the header.
      let ligne = 165;
      const stops = this.routetransportfromquotation || [];
      const numbered = stops.length > 1;
      stops.forEach((value, index) => {
        const [adresse, societe, tel] = routeStopFields(value.addresses);
        const prefix = numbered ? index + 1 + ". " : "";

        doc.setFontType("bold");
        doc.setFont("Amiri");
        doc.text(60, 160 + index * 10, prefix + societe + " (tel:" + tel + ")");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.text(60, 165 + index * 10, adresse + this.gpsSuffix(value.latitude, value.longitude));

        ligne = 165 + index * 10;
      });
      // OBSER 1
      doc.setFontType("bold");
      doc.text(30, ligne + 10, "Observatii 1:");
      doc.setFontType("normal");
      doc.text(60, ligne + 10, "Clientul trebuie anuntat cu cel putin 3 ore inainte de ajungerea camionului, pentru a se putea");
      doc.text(60, ligne + 15, "organiza in vederea descarcarii.");
      // OBSER 2
      doc.setFontType("bold");
      doc.text(30, ligne + 25, "Observatii 2:");
      doc.setFontType("normal");
      doc.text(60, ligne + 25, "Confirmarea pe CMR Semnatura+Stampila sau Semnatura+Numele in clar al celui care semneaza");
      // Pret negociat2223
      doc.setFontType("bold");
      doc.text(30, ligne + 35, "Pret negociat:");
      doc.setFontType("normal");
      doc.text(60, ligne + 35, Math.abs(this.user_data.products[0].operations_products.unit_price).toFixed(2) + " EUR+TVA");
      if (this.user_data.transport_payment_method == 'direct') {
        doc.text(60, ligne + 40, "Plata cu OP contra documente transmise pe mail invoice@xyloimpact.com");
      } else if (this.user_data.transport_payment_method == '5 days') {
        doc.text(60, ligne + 40, "Plata cu OP, 5 zile de la primirea documentelor pe mail invoice@xyloimpact.com");
      } else if (this.user_data.transport_payment_method == '10 days') {
        doc.text(60, ligne + 40, "Plata cu OP, 10 zile de la primirea documentelor pe mail invoice@xyloimpact.com");
      } else if (this.user_data.transport_payment_method == '15 days') {
        doc.text(60, ligne + 40, "Plata cu OP, 15 zile de la primirea documentelor pe mail invoice@xyloimpact.com");
      } else {
        doc.text(60, ligne + 40, "Plata cu OP, 30 zile de la primirea documentelor pe mail invoice@xyloimpact.com");
      }
      //doc.text(60, ligne + 45, "Factura trebuie transmisa pe invoice@xyloimpact.com");
      doc.addImage(img_logo_acacia_bois, "JPEG", 30, ligne + 55, 25, 25);
      doc.setFontType("bold");
      doc.text(30, ligne + 90, "XYLO IMPACT SRL");
      doc.setFontType("normal");
      doc.text(30, ligne + 95, "Clément VANDENPLAS");
      doc.setFontSize(6);
      doc.text(30, ligne + 99, "(RO) +40 (0) 752 061 451 / (BE) +32 (0) 498 217 581");
      doc.setFontSize(8);
      doc.text(120, ligne + 90, "Transportator,");
      doc.setFontType("bold");
      // `people` is an array: `.size` is undefined, so this always printed
      // "Not defined" even when the carrier was set.
      doc.text(120, ligne + 95, this.transporterName() || "Not defined");
      doc.setFontType("normal");
      doc.save(
        +moment(this.user_data.date).format("YYYYMMDD") +
        "_" +
        this.user_data.operationcategory.name_en +
        "_" +
        this.user_data.id +
        ".pdf"
      );
    },
    GenerateDocumentReceptionNew() {
      if (this.warnDocumentBlocked()) return;
      const doc = new jsPDF();
      doc.addFileToVFS("Amiri-Regular.ttf", AmiriRegular);
      doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
      doc.addFont("Amiri-Regular.ttf", "Amiri Italic", "italic");
      doc.setFont("Amiri");

      for (let i = 0; i < this.routetransport.length; i++) {

        if (i !== 0) doc.addPage();
        var diviseuraddresscontact = routeStopFields(this.routetransport[i].addresses);
        var strtitre = null;
        var strfurnizor = null;
        var strsediul = null;
        var strpunctdelucru = null;
        var strtransport = null;
        var strdestinatar = null;
        var strspecificatia = null;
        var strprodusambalajetc = null;
        var strproduslungimediametruperimetru = null;
        var strcantitate = null;
        var strfacturascopuri = null;
        var strdindatade = null;
        var strprinsemareablabla = null;
        var strnumeledestinarului = null;
        var strtva = null;
        var stridentitateapersoanelorcare = null;
        var strdata = null;
        var strsemnatura = null;
        var strfsc = null;

        var strtitreRo = "AVIZ DE INSOTIRE A MARFII";
        if (diviseuraddresscontact[4] == "2") {
          //FR
          if (this.routetransport[i].fsc) {
          strfsc = "Les produits identifiés sur ce document sont certifiés FSC 100%, certification n°: SGSCH-COC-011793."
          } else {
            strfsc = null;
          }
          strtitre = "Déclaration de réception des marchandises";
          strfurnizor = "Fournisseur";
          strsediul = "Siège social";
          strpunctdelucru = "Poste de travail";
          strtransport = "Transport";
          strdestinatar = "Destinataire";
          strspecificatia = "Spécification";
          strprodusambalajetc = "(Produits, emballages, etc.)";
          strproduslungimediametruperimetru =
            "Produit (L = Longueur ; d = Diamètre ; P = Périmètre)";
          strcantitate = "Montant";
          strfacturascopuri = "Facture / Objectifs";
          strdindatade = "Daté du";
          strprinsemareablabla =
            "En signant cette Déclaration de Réception de Marchandises, le Destinataire reconnaît avoir reçu tous les produits\nmentionnés dans le tableau ci-dessus.";
          strnumeledestinarului = "Nom du destinataire:";
          strtva = "T.V.A:";
          stridentitateapersoanelorcare =
            "Identité des personnes acceptant les marchandises :";
          strdata = "Date:";
          strsemnatura = "Signature";
        } else if (diviseuraddresscontact[4] == "3") {
          //RO
          if (this.routetransport[i].fsc) {
          strfsc = "Produsele identificate  în acest document sunt certificate 100% FSC. Numărul certificării: SGSCH-COC-011793."
          } else {
            strfsc = null;
          }
          strtitre = "Declarația privind primirea bunurilor";
          strfurnizor = "Furnizor";
          strsediul = "Sediul";
          strpunctdelucru = "Punct de lucru";
          strtransport = "Transport";
          strdestinatar = "Destinatar";
          strspecificatia = "Specificatia";
          strprodusambalajetc = "(Produse, ambalaje, etc.)";
          strproduslungimediametruperimetru =
            "Produs (L = Lungime; d = diametru; P = Perimetru)";
          strcantitate = "Cantitate";
          strfacturascopuri = "Factura/Scopuri";
          strdindatade = "Din data de ";
          strprinsemareablabla =
            "Prin semnarea acestei Declarații de Primire a Bunurilor, Destinatarul recunoaște că a primit toate produselor\nmentionate in tabelul de mai sus.";
          strnumeledestinarului = "Numele Destinatarului: ";
          strtva = "TVA:";
          stridentitateapersoanelorcare =
            "Identitatea persoanelor care accept bunurile: ";
          strdata = "Data: ";
          strsemnatura = "Semnatura";
        } else if (diviseuraddresscontact[4] == "4") {
          //DE
          if (this.routetransport[i].fsc) {
          strfsc = "Die in diesem Dokument  identifizierten Produkte sind 100% FSC-zertifiziert. Zertifikatsnummer:  SGSCH-COC-011793."
          } else {
            strfsc = null;
          }
          strtitre = "Wareneingangserklärung";
          strfurnizor = "Anbieter";
          strsediul = "Hauptquartier";
          strpunctdelucru = "Arbeitsplatz";
          strtransport = "Transport";
          strdestinatar = "Empfänger";
          strspecificatia = "Spezifikation";
          strprodusambalajetc = "(Produkte, Verpackungen usw.)";
          strproduslungimediametruperimetru =
            "Produkt (L = Länge; d = Durchmesser; P = Umfang)";
          strcantitate = "Menge";
          strfacturascopuri = "Rechnung / Verwendungszweck";
          strdindatade = "Zeitpunkt";
          strprinsemareablabla =
            "Mit der Unterzeichnung dieser Wareneingangserklärung bestätigt der Empfänger, dass er alle in der obigen Tabelle\naufgeführten Produkte erhalten hat.";
          strnumeledestinarului = "Name des Empfängers:";
          strtva = "Mehrwertsteuer:";
          stridentitateapersoanelorcare =
            "Identität der Personen, die die Ware annehmen:";
          strdata = "Datum:";
          strsemnatura = "Unterschrift";
        } else if (diviseuraddresscontact[4] == "5") {
          //ES
          if (this.routetransport[i].fsc) {
          strfsc = "Los productos  identificados en este documento están certificados 100% FSC. Número de  certificación: SGSCH-COC-011793."
          } else {
            strfsc = null;
          }

          strtitre = "Declaración de recepción de mercancías";
          strfurnizor = "proveedor";
          strsediul = "sede";
          strpunctdelucru = "Puesto de trabajo";
          strtransport = "Transporte";
          strdestinatar = "Consignatario";
          strspecificatia = "Especificación";
          strprodusambalajetc = "(Productos, envases, etc.)";
          strproduslungimediametruperimetru =
            "Producto (L = Longitud; d = Diámetro; P = Perímetro)";
          strcantitate = "Monto";
          strfacturascopuri = "Factura / Propósitos";
          strdindatade = "Fecha";
          strprinsemareablabla =
            "Al firmar esta Declaración de Recepción de Mercancías, el Destinatario reconoce que ha recibido todos los productos\nmencionados en la tabla anterior.";
          strnumeledestinarului = "Nombre del destinatario:";
          strtva = "IVA:";
          stridentitateapersoanelorcare =
            "Identidad de las personas que aceptan las mercancías:";
          strdata = "Fecha:";
          strsemnatura = "Firma";
        } else if (diviseuraddresscontact[4] == "6") {
          //NL
          if (this.routetransport[i].fsc) {
          strfsc = "De producten die op dit  document zijn geïdentificeerd, zijn 100% FSC gecertificeerd.  Certificatienummer: SGSCH-COC-011793."
          } else {
            strfsc = null;
          }
          strtitre = "Verklaring van ontvangst van goederen";
          strfurnizor = "aanbieder";
          strsediul = "hoofdkwartier";
          strpunctdelucru = "Werkstation";
          strtransport = "Vervoer";
          strdestinatar = "Geadresseerde";
          strspecificatia = "Specificatie";
          strprodusambalajetc = "(Producten, verpakkingen, enz.)";
          strproduslungimediametruperimetru =
            "Product (L = lengte; d = diameter; P = omtrek)";
          strcantitate = "Hoeveelheid";
          strfacturascopuri = "Factuur / doeleinden";
          strdindatade = "Vanaf";
          strprinsemareablabla =
            "Door deze verklaring van ontvangst van goederen te ondertekenen, erkent de ontvanger dat hij alle producten heeft\nontvangen die in de bovenstaande tabel worden vermeld.";
          strnumeledestinarului = "Naam ontvanger:";
          strtva = "VAT:";
          stridentitateapersoanelorcare =
            "Identiteit van de personen die de goederen in ontvangst nemen:";
          strdata = "Datum:";
          strsemnatura = "Handtekening";
        } else {
          //EN
          if (this.routetransport[i].fsc) {
          strfsc = "The products identified  on this document are 100% FSC certified. Certification number:  SGSCH-COC-011793."
          } else {
            strfsc = null;
          }
          strtitre = "Declaration of receipt of goods";
          strfurnizor = "Provider";
          strsediul = "headquarters";
          strpunctdelucru = "Workstation";
          strtransport = "Transport";
          strdestinatar = "Consignee";
          strspecificatia = "Specification";
          strprodusambalajetc = "(Products, packaging, etc.)";
          strproduslungimediametruperimetru =
            "Product (L = Length; d = Diameter; P = Perimeter)";
          strcantitate = "Amount";
          strfacturascopuri = "Invoice / Purposes";
          strdindatade = "dated";
          strprinsemareablabla =
            "By signing this Declaration of Receipt of Goods, the Recipient acknowledges that he has received all the\nproducts mentioned in the table above.";
          strnumeledestinarului = "Recipient's name:";
          strtva = "VAT:";
          stridentitateapersoanelorcare =
            "Identity of persons accepting the goods:";
          strdata = "Date:";
          strsemnatura = "Signature";
        }
        const renderPageHeader = (
          includeFullHeader,
          pageNumber,
          totalPages
        ) => {
          if (!includeFullHeader) {
            doc.addPage();
          }
          doc.setFont("Amiri");
          doc.setFontType("bold");
          doc.setFontSize(10);
          doc.text(
            10,
            10,
            "Seria " +
              this.routetransport[i].aviz_serie +
              "  nr. " +
              this.routetransport[i].aviz_number
          );
          doc.text(72, 10, strtitre);
          doc.setFontSize(10);
          doc.setFontType("italic");
          doc.text(80, 15, strtitreRo);
          doc.setFontType("normal");
          doc.text(
            174,
            10,
            strdata +
              " " +
              moment(this.routetransport[i].date).format("DD/MM/YYYY")
          );
          doc.setFontSize(9);
          doc.text(170, 17, "Page " + pageNumber + "/" + totalPages);
          doc.setFont("Amiri");

          if (includeFullHeader) {

            doc.setLineWidth(0.5);
            doc.line(10, 20, 200, 20); // horizon top
            doc.line(10, 20, 10, 75); // vertical left
            doc.line(200, 20, 200, 75); // vertical right
            doc.line(10, 75, 200, 75); // horizon down
            doc.line(73.33, 20, 73.33, 75); // vertical midleft
            doc.line(136.67, 20, 136.67, 75); // vertical midright

            // UNLOADING CONTACT
            doc.line(10, 82, 200, 82); // horizon down
            doc.line(10, 75, 10, 82); // vertical left
            doc.line(200, 75, 200, 82); // vertical right
            doc.setFontType("bold");
            doc.setFontSize(12);
            doc.text(13, 80, "Contact de descarcare/Unloading Contact:");
            doc.setFontType("italic");
            doc.setFontSize(10);
            doc.text(92, 80, "Mariana Nagy (Tel: +40 752 170 031)");
            doc.setFontType("normal");

            // FUNIZOR
            doc.setFontSize(14);
            doc.setFontType("bold");
            doc.setFont("Amiri");
            doc.text(13, 26, strfurnizor + ":");
            doc.setFontType("normal");
            doc.setFont("Amiri");
            doc.setFontSize(9);
            doc.setFontType("bold");
            doc.text(13, 31, "SC XYLO IMPACT SRL");
            doc.setFontType("normal");
            doc.setFont("Amiri");
            doc.setFontSize(9);

            doc.text(13, 35, "TVA: RO33531190");
            doc.setFontType("bold");
            doc.setFont("Amiri");
            doc.text(13, 43, strsediul);
            doc.setFontType("normal");
            doc.text(13, 47, "Strada Principala 115A,");
            doc.text(13, 51, "337291 Teiu,");
            doc.text(13, 55, "Jud. Hunedoara (Romania)");
            doc.setFontType("bold");
            doc.text(13, 61, strpunctdelucru);
            doc.setFontType("normal");
            doc.text(13, 65, "Sat TEIU, Com. Lapugiu de Jos,");
            doc.text(13, 69, "Jud. Hunedoara (Romania)");

            // TRANSPORTER
            doc.setFontSize(14);
            doc.setFontType("bold");
            doc.setFont("Amiri");
            doc.text(76.33, 26, strtransport + ":");
            doc.setFontType("normal");
            doc.setFont("Amiri");
            doc.setFontSize(12);
            doc.setFontSize(9);
            doc.setFontType("bold");
            doc.setFont("Amiri");
            doc.text(
              76.33,
              31,
              this.user_data.people[0].company_name.substring(0, 35)
            );
            doc.setFontType("normal");
            doc.setFont("Amiri");
            doc.setFontSize(9);
            doc.text(
              76.33,
              35,
              strtva + " " + this.user_data.people[0].vat_number
            );

            if (this.user_data.people[0].addresses[0]) {
              drawAddressBlock(doc, fromPersonAddress(this.user_data.people[0].addresses[0]), 76.33, 43, 4);
            } else doc.text(76.33, 43, "Address: NO DATA");
            // DESTINATAR
            doc.setFontSize(14);
            doc.setFontType("bold");
            doc.setFont("Amiri");
            doc.text(139.67, 26, strdestinatar + ":");
            doc.setFontType("normal");
            doc.setFont("Amiri");
            doc.setFontSize(9);
            doc.setFontType("bold");
            doc.setFont("Amiri");
            if (diviseuraddresscontact[1]) {
              doc.text(139.67, 31, diviseuraddresscontact[1].substring(0, 30));
              if (diviseuraddresscontact[1].length > 30) {
                doc.text(139.67, 35, diviseuraddresscontact[1].substring(30, 60));
              }
            }
            doc.setFontType("normal");
            doc.setFont("Amiri");
            doc.setFontSize(9);
            doc.text(139.67, 39, diviseuraddresscontact[2]);
            // `addressLine1/2` : la 2e ligne pouvait etre undefined sur une
            // adresse sans virgule, et jsPDF plantait.
            var stopaddress = parseRouteAddress(this.routetransport[i].addresses);
            doc.text(139.67, 45, (stopaddress.addressLine1 || "-") + ",");
            doc.text(139.67, 49, stopaddress.addressLine2 || "");
          }

          const tableTopY = includeFullHeader ? 100 : 60;
          const tableBottomY = tableTopY + 140;

          doc.setLineWidth(0.5);
          doc.line(10, tableTopY, 200, tableTopY); // horizon top
          doc.line(10, tableTopY, 10, tableBottomY); // vertical left
          doc.line(200, tableTopY, 200, tableBottomY); // vertical right
          doc.line(10, tableBottomY, 200, tableBottomY); // horizon down
          doc.line(170, tableTopY, 170, tableBottomY); // vertical midright
          doc.setFontSize(14);
          doc.setFontType("bold");
          doc.text(13, tableTopY - 7, strspecificatia + ":");
          doc.setFontType("italic");
          doc.setFontSize(12);
          doc.text(13, tableTopY - 2, strprodusambalajetc);
          doc.setFontType("bold");
          doc.setFontSize(9);
          doc.text(12, tableTopY + 5, "CRT");
          doc.line(20, tableTopY, 20, tableBottomY); // vertical 1
          doc.text(23, tableTopY + 5, strproduslungimediametruperimetru);
          doc.line(137, tableTopY, 137, tableBottomY); // vertical 3
          doc.text(140, tableTopY + 5, strcantitate);
          doc.text(173, tableTopY + 5, strfacturascopuri);
          doc.line(10, tableTopY + 8, 200, tableTopY + 8); // horizon top
          doc.setFontType("normal");
          doc.setFont("Amiri");

          return {
            productStartY: tableTopY + 10,
            tableBottomY,
          };
        };

        const filteredProducts = this.cmrproduct.filter(
          (value) =>
            value.id === this.routetransport[i].id &&
            value.category !== "Services"
        );

        const maxRowsPerPage = 15;
        const rowHeight = 8;
        const totalPages = Math.max(
          1,
          Math.ceil(filteredProducts.length / maxRowsPerPage)
        );

        let currentPageNumber = 1;
        let tableConfig = renderPageHeader(true, currentPageNumber, totalPages);
        let productStartY = tableConfig.productStartY;
        let tableBottomY = tableConfig.tableBottomY;
        let rowsOnCurrentPage = 0;
        let totalProductsCount = 0;
        doc.setFont("Amiri");
        let sumQuantity = 0;
        let sumVolume = 0;

        const ensurePageCapacity = () => {
          if (rowsOnCurrentPage === maxRowsPerPage) {
            currentPageNumber += 1;
            tableConfig = renderPageHeader(
              false,
              currentPageNumber,
              totalPages
            );
            productStartY = tableConfig.productStartY;
            tableBottomY = tableConfig.tableBottomY;
            rowsOnCurrentPage = 0;
          }
        };

        filteredProducts.forEach((value) => {
          ensurePageCapacity();
          rowsOnCurrentPage += 1;
          totalProductsCount += 1;
          const currentRowY = productStartY + rowsOnCurrentPage * rowHeight;

          doc.text(12, currentRowY, totalProductsCount.toString());
          doc.setFontType("normal");
          doc.setFontSize(10);
          const categoryText = value.category_language_client || "";
          const truncatedText =
            categoryText.length > 70
              ? categoryText.substring(0, 70) + "..."
              : categoryText;
          doc.text(23, currentRowY, truncatedText);
          doc.setFontType("normal");
          doc.setFontSize(8);
          doc.setTextColor(128, 128, 128); // Gris
          doc.text(
            23,
            currentRowY + 3,
            "RO:" + (value.name_romanian || "")
          );
          doc.setTextColor(0, 0, 0); // Remettre en noir
          sumQuantity = sumQuantity + parseFloat(value.quantity);
          sumVolume = sumVolume + parseFloat(value.volume);
          doc.text(140, currentRowY, value.quantity + " " + value.uom);
          if (totalProductsCount === 1) {
            doc.text(171, currentRowY, value.invoice_no);
          }
          doc.setFontSize(7);
          if (totalProductsCount === 1)
            doc.text(
              171,
              currentRowY + 3,
              "(" + strdindatade + " " + value.date + ")"
            );
          doc.setFontSize(9);
        });

        const totalsBaseY = Math.min(
          tableBottomY - 12,
          productStartY + rowsOnCurrentPage * rowHeight + 4
        );
        doc.text(140, totalsBaseY, "------------");
        doc.text(140, totalsBaseY + 3, "Total pcs : " + sumQuantity + " Pcs");
        doc.text(
          140,
          totalsBaseY + 6,
          "Total vol.: " + parseFloat(sumVolume).toFixed(2) + " m3"
        );


        doc.setFontType("italic");
        doc.setFontSize(7);
        doc.setTextColor(255, 0, 0);
        doc.text(
          21,
          112,
          strfsc ? strfsc : ""
        );
        doc.setTextColor(0, 0, 0);
        // TEXT BOTTOM
        doc.setFontSize(10);
        doc.setFontType("italic");
        doc.text(
          13,
          250,
          "Produsele ce fac obiectul prezentei facturi nu sunt “materiale lemnoase” astfel cum sunt acestea definite la pct. 21 din Anexa la\nLegea nr. 46/2008 (modificata) pentru aprobarea Codului Silvic si nu fac obiectul prevederilor Regulamentului (UE) nr. 995/2010\nal Parlamentului European si al Consiliului, intrucat costituie produse finite (STALPI decojiti, ascutiti, paletizate, parafinate),\nsi circula in acord cu regulile UE privind circulatia marfurilor in Comunitatea Europeana."
        );

        // SEMNATURA
        doc.setFontSize(10);
        doc.setFontType("normal");
        doc.text(13, 275, "Semnatura si stampila\nfurnizorului:");
        doc.text(67, 275, "Am incarcat\n(nume, prenume, semnatura):");
        doc.text(136, 275, "Am verificat\n(nume, prenume, semnatura):");
      }

      // SAVER
      doc.save(
        +moment(this.user_data.date).format("YYYYMMDD") +
        "_declaratiaPrivindPrimireaBunurilor_" +
        this.user_data.operationcategory.name_en +
        "_" +
        this.user_data.id +
        ".pdf"
      );
    },
    GenerateDocumentReception() {
      if (this.warnDocumentBlocked()) return;
      const doc = new jsPDF();
      doc.addFileToVFS("Amiri-Regular.ttf", AmiriRegular);
      doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
      doc.setFont("Amiri");

      for (let i = 0; i < this.routetransport.length; i++) {
        if (i !== 0) doc.addPage();
        var diviseuraddresscontact = routeStopFields(this.routetransport[i].addresses);
        var strtitre = null;
        var strfurnizor = null;
        var strsediul = null;
        var strpunctdelucru = null;
        var strtransport = null;
        var strdestinatar = null;
        var strspecificatia = null;
        var strprodusambalajetc = null;
        var strproduslungimediametruperimetru = null;
        var strcantitate = null;
        var strfacturascopuri = null;
        var strdindatade = null;
        var strprinsemareablabla = null;
        var strnumeledestinarului = null;
        var strtva = null;
        var stridentitateapersoanelorcare = null;
        var strdata = null;
        var strsemnatura = null;

        if (diviseuraddresscontact[4] == "2") {
          //FR
          strtitre = "Déclaration de réception des marchandises";
          strfurnizor = "Fournisseur";
          strsediul = "Siège social";
          strpunctdelucru = "Poste de travail";
          strtransport = "Transport";
          strdestinatar = "Destinataire";
          strspecificatia = "Spécification";
          strprodusambalajetc = "(Produits, emballages, etc.)";
          strproduslungimediametruperimetru =
            "Produit (L = Longueur ; d = Diamètre ; P = Périmètre)";
          strcantitate = "Montant";
          strfacturascopuri = "Facture / Objectifs";
          strdindatade = "Daté du";
          strprinsemareablabla =
            "En signant cette Déclaration de Réception de Marchandises, le Destinataire reconnaît avoir reçu tous les produits\nmentionnés dans le tableau ci-dessus.";
          strnumeledestinarului = "Nom du destinataire:";
          strtva = "T.V.A:";
          stridentitateapersoanelorcare =
            "Identité des personnes acceptant les marchandises :";
          strdata = "Date:";
          strsemnatura = "Signature";
        } else if (diviseuraddresscontact[4] == "3") {
          //RO
          strtitre = "Declarația privind primirea bunurilor";
          strfurnizor = "Furnizor";
          strsediul = "Sediul";
          strpunctdelucru = "Punct de lucru";
          strtransport = "Transport";
          strdestinatar = "Destinatar";
          strspecificatia = "Specificatia";
          strprodusambalajetc = "(Produse, ambalaje, etc.)";
          strproduslungimediametruperimetru =
            "Produs (L = Lungime; d = diametru; P = Perimetru)";
          strcantitate = "Cantitate";
          strfacturascopuri = "Factura/Scopuri";
          strdindatade = "Din data de ";
          strprinsemareablabla =
            "Prin semnarea acestei Declarații de Primire a Bunurilor, Destinatarul recunoaște că a primit toate produselor\nmentionate in tabelul de mai sus.";
          strnumeledestinarului = "Numele Destinatarului: ";
          strtva = "TVA:";
          stridentitateapersoanelorcare =
            "Identitatea persoanelor care accept bunurile: ";
          strdata = "Data: ";
          strsemnatura = "Semnatura";
        } else if (diviseuraddresscontact[4] == "4") {
          //DE
          strtitre = "Wareneingangserklärung";
          strfurnizor = "Anbieter";
          strsediul = "Hauptquartier";
          strpunctdelucru = "Arbeitsplatz";
          strtransport = "Transport";
          strdestinatar = "Empfänger";
          strspecificatia = "Spezifikation";
          strprodusambalajetc = "(Produkte, Verpackungen usw.)";
          strproduslungimediametruperimetru =
            "Produkt (L = Länge; d = Durchmesser; P = Umfang)";
          strcantitate = "Menge";
          strfacturascopuri = "Rechnung / Verwendungszweck";
          strdindatade = "Zeitpunkt";
          strprinsemareablabla =
            "Mit der Unterzeichnung dieser Wareneingangserklärung bestätigt der Empfänger, dass er alle in der obigen Tabelle\naufgeführten Produkte erhalten hat.";
          strnumeledestinarului = "Name des Empfängers:";
          strtva = "Mehrwertsteuer:";
          stridentitateapersoanelorcare =
            "Identität der Personen, die die Ware annehmen:";
          strdata = "Datum:";
          strsemnatura = "Unterschrift";
        } else if (diviseuraddresscontact[4] == "5") {
          //ES
          strtitre = "Declaración de recepción de mercancías";
          strfurnizor = "proveedor";
          strsediul = "sede";
          strpunctdelucru = "Puesto de trabajo";
          strtransport = "Transporte";
          strdestinatar = "Consignatario";
          strspecificatia = "Especificación";
          strprodusambalajetc = "(Productos, envases, etc.)";
          strproduslungimediametruperimetru =
            "Producto (L = Longitud; d = Diámetro; P = Perímetro)";
          strcantitate = "Monto";
          strfacturascopuri = "Factura / Propósitos";
          strdindatade = "Fecha";
          strprinsemareablabla =
            "Al firmar esta Declaración de Recepción de Mercancías, el Destinatario reconoce que ha recibido todos los productos\nmencionados en la tabla anterior.";
          strnumeledestinarului = "Nombre del destinatario:";
          strtva = "IVA:";
          stridentitateapersoanelorcare =
            "Identidad de las personas que aceptan las mercancías:";
          strdata = "Fecha:";
          strsemnatura = "Firma";
        } else if (diviseuraddresscontact[4] == "6") {
          //NL
          strtitre = "Verklaring van ontvangst van goederen";
          strfurnizor = "aanbieder";
          strsediul = "hoofdkwartier";
          strpunctdelucru = "Werkstation";
          strtransport = "Vervoer";
          strdestinatar = "Geadresseerde";
          strspecificatia = "Specificatie";
          strprodusambalajetc = "(Producten, verpakkingen, enz.)";
          strproduslungimediametruperimetru =
            "Product (L = lengte; d = diameter; P = omtrek)";
          strcantitate = "Hoeveelheid";
          strfacturascopuri = "Factuur / doeleinden";
          strdindatade = "Vanaf";
          strprinsemareablabla =
            "Door deze verklaring van ontvangst van goederen te ondertekenen, erkent de ontvanger dat hij alle producten heeft\nontvangen die in de bovenstaande tabel worden vermeld.";
          strnumeledestinarului = "Naam ontvanger:";
          strtva = "VAT:";
          stridentitateapersoanelorcare =
            "Identiteit van de personen die de goederen in ontvangst nemen:";
          strdata = "Datum:";
          strsemnatura = "Handtekening";
        } else {
          //EN
          strtitre = "Declaration of receipt of goods";
          strfurnizor = "Provider";
          strsediul = "headquarters";
          strpunctdelucru = "Workstation";
          strtransport = "Transport";
          strdestinatar = "Consignee";
          strspecificatia = "Specification";
          strprodusambalajetc = "(Products, packaging, etc.)";
          strproduslungimediametruperimetru =
            "Product (L = Length; d = Diameter; P = Perimeter)";
          strcantitate = "Amount";
          strfacturascopuri = "Invoice / Purposes";
          strdindatade = "dated";
          strprinsemareablabla =
            "By signing this Declaration of Receipt of Goods, the Recipient acknowledges that he has received all the\nproducts mentioned in the table above.";
          strnumeledestinarului = "Recipient's name:";
          strtva = "VAT:";
          stridentitateapersoanelorcare =
            "Identity of persons accepting the goods:";
          strdata = "Date:";
          strsemnatura = "Signature";
        }
        doc.setFontType("bold");
        doc.setFontSize(10);
        doc.text(
          10,
          10,
          "Seria " +
          this.routetransport[i].aviz_serie +
          "  nr. " +
          this.routetransport[i].aviz_number
        );
        doc.text(80, 10, strtitre);
        doc.text(
          174,
          10,
          strdata +
          " " +
          moment(this.routetransport[i].date).format("DD/MM/YYYY")
        );
        doc.setFontType("normal");

        doc.setLineWidth(0.5);
        doc.line(10, 20, 200, 20); // horizon top
        doc.line(10, 20, 10, 75); // vertical left
        doc.line(200, 20, 200, 75); // vertical right
        doc.line(10, 75, 200, 75); // horizon down
        doc.line(73.33, 20, 73.33, 75); // vertical midleft
        doc.line(136.67, 20, 136.67, 75); // vertical midright

        // UNLOADING CONTACT
        doc.line(10, 82, 200, 82); // horizon down
        doc.line(10, 75, 10, 82); // vertical left
        doc.line(200, 75, 200, 82); // vertical right
        doc.setFontType("bold");
        doc.setFontSize(12);
        doc.text(13, 80, "Contact de descarcare/Unloading Contact:");
        doc.setFontType("italic");
        doc.setFontSize(10);
        doc.text(92, 80, "Mariana Nagy (Tel: +40 752 170 031)");
        doc.setFontType("normal");

        // FUNIZOR
        doc.setFontSize(14);
        doc.setFontType("bold");
        doc.setFont("Amiri");
        doc.text(13, 26, strfurnizor + ":");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(9);
        doc.setFontType("bold");
        doc.text(13, 31, "SC XYLO IMPACT SRL");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(9);

        doc.text(13, 35, "TVA: RO33531190");
        doc.setFontType("bold");
        doc.setFont("Amiri");
        doc.text(13, 43, strsediul);
        doc.setFontType("normal");
        doc.text(13, 47, "Strada Principala 115A,");
        doc.text(13, 51, "337291 Teiu,");
        doc.text(13, 55, "Jud. Hunedoara (Romania)");
        doc.setFontType("bold");
        doc.text(13, 61, strpunctdelucru);
        doc.setFontType("normal");
        doc.text(13, 65, "Sat TEIU, Com. Lapugiu de Jos,");
        doc.text(13, 69, "Jud. Hunedoara (Romania)");

        // TRANSPORTER
        doc.setFontSize(14);
        doc.setFontType("bold");
        doc.setFont("Amiri");
        doc.text(76.33, 26, strtransport + ":");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(12);
        if (this.user_data.people[0].iscompany) {
          doc.setFontSize(9);
          doc.setFontType("bold");
          doc.setFont("Amiri");
          doc.text(76.33, 31, this.user_data.people[0].company_name);
          doc.setFontType("normal");
          doc.setFont("Amiri");
          doc.setFontSize(9);
          doc.text(
            76.33,
            35,
            strtva + " " + this.user_data.people[0].vat_number
          );
        } else {
          doc.setFontSize(9);
          doc.setFontType("bold");
          doc.setFont("Amiri");
          doc.text(
            76.33,
            31,
            this.user_data.people[0].firstname +
            " " +
            this.user_data.people[0].lastname
          );
          doc.setFontType("normal");
          doc.setFont("Amiri");
          doc.setFontSize(9);
        }

        if (this.user_data.people[0].addresses[0]) {
          drawAddressBlock(doc, fromPersonAddress(this.user_data.people[0].addresses[0]), 76.33, 43, 4);
        } else doc.text(76.33, 43, "Address: NO DATA");
        // DESTINATAR
        doc.setFontSize(14);
        doc.setFontType("bold");
        doc.setFont("Amiri");
        doc.text(139.67, 26, strdestinatar + ":");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(9);
        doc.setFontType("bold");
        doc.setFont("Amiri");
        doc.text(139.67, 31, diviseuraddresscontact[1]);
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(9);
        doc.text(139.67, 35, diviseuraddresscontact[2]);
        var stopaddress = parseRouteAddress(this.routetransport[i].addresses);
        doc.text(139.67, 43, (stopaddress.addressLine1 || "-") + ",");
        doc.text(139.67, 47, stopaddress.addressLine2 || "");

        // PRODUIT
        doc.setFontSize(14);
        doc.setFontType("bold");
        doc.setFont("Amiri");
        doc.text(13, 93, strspecificatia + ":");
        doc.setFontType("italic");
        doc.setFontSize(12);
        doc.text(13, 98, strprodusambalajetc);
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setLineWidth(0.5);
        doc.line(10, 100, 200, 100); // horizon top
        doc.line(10, 100, 10, 190); // vertical left
        doc.line(200, 100, 200, 190); // vertical right
        doc.line(10, 190, 200, 190); // horizon down
        doc.line(170, 100, 170, 190); // vertical midright
        doc.setFontSize(9);
        doc.setFontType("bold");
        doc.setFont("Amiri");
        doc.setLineWidth(0.1);
        doc.text(12, 105, "CRT");
        doc.line(20, 100, 20, 190); // vertical 1
        doc.text(23, 105, strproduslungimediametruperimetru);
        doc.line(137, 100, 137, 190); // vertical 3
        doc.text(140, 105, strcantitate);
        doc.text(173, 105, strfacturascopuri);
        doc.line(10, 108, 200, 108); // horizon top
        doc.setFontType("normal");
        doc.setFont("Amiri");

        // PRODUCT!!!
        let z = 0;
        doc.setFont("Amiri");
        let sumQuantity = 0;
        let sumVolume = 0;
        this.cmrproduct.forEach((value, index) => {
          if (value.id === this.routetransport[i].id) {
            if (value.category != "Services") {
              z++;
              doc.text(12, 110 + z * 4, z.toString());
              doc.text(23, 110 + z * 4, value.category_language_client);
              sumQuantity = sumQuantity + parseFloat(value.quantity);
              sumVolume = sumVolume + parseFloat(value.volume);
              doc.text(140, 110 + z * 4, value.quantity + " " + value.uom);
              if (z == 1) doc.text(171, 110 + z * 4, value.invoice_no);
              doc.setFontSize(7);
              if (z == 1)
                doc.text(
                  171,
                  113 + z * 4,
                  "(" + strdindatade + " " + value.date + ")"
                );
              doc.setFontSize(9);
            }
          }
        });
        doc.text(140, 113 + z * 4, "------------");
        doc.text(140, 116 + z * 4, "Total pcs : " + sumQuantity + " Pcs");
        doc.text(
          140,
          119 + z * 4,
          "Total vol.: " + parseFloat(sumVolume).toFixed(2) + " m3"
        );

        // TEXT BOTTOM
        doc.setFontSize(10);
        doc.setFont("Amiri");
        doc.setFontType("italic");
        doc.text(13, 205, strprinsemareablabla);

        doc.text(
          13,
          225,
          strnumeledestinarului + " " + diviseuraddresscontact[1]
        );

        doc.text(13, 235, strtva + " " + diviseuraddresscontact[3]);

        doc.text(13, 245, stridentitateapersoanelorcare);
        doc.text(13, 255, strdata);
        doc.text(13, 265, strsemnatura);
      }

      // SAVER
      doc.save(
        +moment(this.user_data.date).format("YYYYMMDD") +
        "_declaratiaPrivindPrimireaBunurilor_" +
        this.user_data.operationcategory.name_en +
        "_" +
        this.user_data.id +
        ".pdf"
      );
    },
    GenerateDocumentAviz() {
      if (this.warnDocumentBlocked()) return;
      const doc = new jsPDF();
      doc.addFileToVFS("Amiri-Regular.ttf", AmiriRegular);
      doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
      doc.setFont("Amiri");

      for (let i = 0; i < this.routetransport.length; i++) {
        if (i !== 0) doc.addPage();
        doc.setFontType("bold");
        doc.setFontSize(10);
        doc.text(
          10,
          10,
          "Seria " +
          this.routetransport[i].aviz_serie +
          "  nr. " +
          this.routetransport[i].aviz_number
        );
        doc.text(80, 10, "AVIZ DE INSOTIRE A MARFII");
        doc.text(
          174,
          10,
          "Data: " + moment(this.routetransport[i].date).format("DD/MM/YYYY")
        );
        doc.setFontType("normal");

        doc.setLineWidth(0.5);
        doc.line(10, 20, 200, 20); // horizon top
        doc.line(10, 20, 10, 75); // vertical left
        doc.line(200, 20, 200, 75); // vertical right
        doc.line(10, 75, 200, 75); // horizon down
        doc.line(73.33, 20, 73.33, 75); // vertical midleft
        doc.line(136.67, 20, 136.67, 75); // vertical midright

        // UNLOADING CONTACT
        doc.line(10, 82, 200, 82); // horizon down
        doc.line(10, 75, 10, 82); // vertical left
        doc.line(200, 75, 200, 82); // vertical right
        doc.setFontType("bold");
        doc.setFontSize(12);

        doc.text(13, 80, "Contact de descarcare/Unloading Contact:");
        doc.setFontType("italic");
        doc.setFontSize(10);
        doc.text(92, 80, "Mariana Nagy (Tel: +40 752 170 031)");
        doc.setFontType("normal");

        // FUNIZOR
        doc.setFontSize(14);
        doc.setFontType("bold");
        doc.text(13, 26, "Furnizor:");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(9);
        doc.setFontType("bold");
        doc.text(13, 31, "SC XYLO IMPACT SRL");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(9);

        doc.text(13, 35, "TVA: RO33531190");
        doc.setFontType("bold");
        doc.text(13, 43, "Sediul: ");
        doc.setFontType("normal");
        doc.text(13, 47, "Strada Principala 115A,");
        doc.text(13, 51, "337291 Teiu,");
        doc.text(13, 55, "Jud. Hunedoara (Romania)");
        doc.setFontType("bold");
        doc.text(13, 61, "Punct de lucru: ");
        doc.setFontType("normal");
        doc.text(13, 65, "Sat TEIU, Com. Lapugiu de Jos,");
        doc.text(13, 69, "Jud. Hunedoara (Romania)");

        // TRANSPORTER
        doc.setFontSize(14);
        doc.setFontType("bold");
        doc.text(76.33, 26, "Transport:");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(12);
        if (this.user_data.people[0].iscompany) {
          doc.setFontSize(9);
          doc.setFontType("bold");
          doc.text(76.33, 31, this.user_data.people[0].company_name.substring(0, 35));
          doc.setFontType("normal");
          doc.setFont("Amiri");
          doc.setFontSize(9);
          doc.text(76.33, 35, "TVA: " + this.user_data.people[0].vat_number);
        } else {
          doc.setFontSize(9);
          doc.setFontType("bold");
          doc.text(
            76.33,
            31,
            this.user_data.people[0].firstname +
            " " +
            this.user_data.people[0].lastname
          );
          doc.setFontType("normal");
          doc.setFont("Amiri");
          doc.setFontSize(9);
        }

        if (this.user_data.people[0].addresses[0]) {
          drawAddressBlock(doc, fromPersonAddress(this.user_data.people[0].addresses[0]), 76.33, 43, 4);
        } else doc.text(76.33, 43, "Address: NO DATA");
        // DESTINATAR
        var stopaddress = parseRouteAddress(this.routetransport[i].addresses);
        var diviseuraddresscontact = routeStopFields(this.routetransport[i].addresses);
        doc.setFontSize(14);
        doc.setFontType("bold");
        doc.text(139.67, 26, "Destinatar:");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(9);
        doc.setFontType("bold");
        doc.text(139.67, 31, diviseuraddresscontact[1].substring(0, 46));
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(9);
        doc.text(139.67, 35, diviseuraddresscontact[2].substring(0, 46));
        doc.text(139.67, 43, (stopaddress.addressLine1 || "-").substring(0, 46) + ",");
        doc.text(139.67, 47, stopaddress.addressLine2.substring(0, 46));

        // PRODUIT
        doc.setFontSize(14);
        doc.setFontType("bold");
        doc.text(13, 93, "Specificatia:");
        doc.setFontType("italic");
        doc.setFontSize(12);
        doc.text(13, 98, "(Produse, ambalaje, etc.)");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setLineWidth(0.5);
        doc.line(10, 100, 200, 100); // horizon top
        doc.line(10, 100, 10, 225); // vertical left
        doc.line(200, 100, 200, 225); // vertical right
        doc.line(10, 225, 200, 225); // horizon down
        doc.line(170, 100, 170, 225); // vertical midright
        doc.setFontSize(9);
        doc.setFontType("bold");
        doc.setLineWidth(0.1);
        doc.text(12, 105, "CRT");
        doc.line(20, 100, 20, 225); // vertical 1
        doc.text(23, 105, "Produs (L = Lungime; d = diametru; P = Perimetru)");
        //doc.line(117, 100, 117, 190); // vertical 2
        //doc.text(120, 105, "Cantitate");
        //doc.line(137, 100, 137, 190); // vertical 3
        //doc.text(140, 105, "Volum Total (m3)");

        doc.line(137, 100, 137, 225); // vertical 3
        doc.text(140, 105, "Cantitate");

        doc.text(173, 105, "Factura/Scopuri");
        doc.line(10, 108, 200, 108); // horizon top
        doc.setFontType("normal");

        // PRODUCT!!!
        let z = 0;
        doc.setFont("Amiri");
        let sumQuantity = 0;
        let sumVolume = 0;
        this.cmrproduct.forEach((value, index) => {
          if (value.id === this.routetransport[i].id) {
            if (value.category != "Services") {
              z++;
              doc.text(12, 110 + z * 4, z.toString());
              doc.text(
                23,
                110 + z * 4,
                value.name.replace(value.category, value.category_ro)
              );
              sumQuantity = sumQuantity + parseFloat(value.quantity);
              if (!isNaN(parseFloat(value.volume))) {
                sumVolume += parseFloat(value.volume);
              }
              doc.text(140, 110 + z * 4, value.quantity + " " + value.uom);
              if (z == 1) doc.text(171, 110 + z * 4, value.invoice_no);
              doc.setFontSize(7);
              if (z == 1)
                doc.text(171, 113 + z * 4, "(Din data de " + value.date + ")");
              doc.setFontSize(9);
            }
          }
        })
        doc.text(140, 113 + z * 4, "------------");
        doc.text(140, 116 + z * 4, "Total pcs : " + sumQuantity + " Pcs");
        doc.text(
          140,
          119 + z * 4,
          "Total vol.: " + parseFloat(sumVolume).toFixed(2) + " m3"
        );

        // TEXT BOTTOM
        doc.setFontSize(10);
        doc.setFontType("italic");
        doc.text(
          13,
          250,
          "Produsele ce fac obiectul prezentei facturi nu sunt “materiale lemnoase” astfel cum sunt acestea definite la pct. 21 din Anexa la\nLegea nr. 46/2008 (modificata) pentru aprobarea Codului Silvic si nu fac obiectul prevederilor Regulamentului (UE) nr. 995/2010\nal Parlamentului European si al Consiliului, intrucat costituie produse finite (STALPI decojiti, ascutiti, paletizate, parafinate),\nsi circula in acord cu regulile UE privind circulatia marfurilor in Comunitatea Europeana."
        );

        // SEMNATURA
        doc.setFontSize(10);
        doc.setFontType("normal");
        doc.text(13, 275, "Semnatura si stampila\nfurnizorului:");
        doc.text(67, 275, "Am incarcat\n(nume, prenume, semnatura):");
        doc.text(136, 275, "Am verificat\n(nume, prenume, semnatura):");
      }

      // SAVER
      doc.save(
        +moment(this.user_data.date).format("YYYYMMDD") +
        "_AVIZ_" +
        this.user_data.operationcategory.name_en +
        "_" +
        this.user_data.id +
        ".pdf"
      );
    },
    GenerateDocumentCMR() {
      if (this.warnDocumentBlocked()) return;
      const doc = new jsPDF();
      doc.addFileToVFS("Amiri-Regular.ttf", AmiriRegular);
      doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
      doc.setFont("Amiri");
      doc.setLineWidth(0.5);
      for (let i = 0; i < this.routetransport.length; i++) {
        // Une seule lecture par arret : les trois `var diviseuraddresscontact`
        // redeclares dans cette meme portee melangeaient les blocs 2, 3 et 13.
        const stop = routeStopFields(this.routetransport[i].addresses);
        if (i !== 0) doc.addPage();
        doc.line(10, 10, 200, 10); // horizon top
        doc.line(10, 10, 10, 285); // vertical left
        doc.line(10, 285, 200, 285); // horizon down
        doc.line(200, 10, 200, 285); // vertical right

        doc.line(105, 10, 105, 135); // vertical middle

        // FIRST ROW // LEFT
        doc.setFontSize(16);
        doc.text(12, 15, "1.");
        doc.setFontSize(6);
        doc.text(17, 15, "Sender (name, address, country)");
        doc.setFontSize(8);
        doc.text(17, 20, "XYLO IMPACT SRL (VAT: RO33531190)");
        doc.text(17, 24, "Strada Principala 115A,");
        doc.text(17, 28, "337291 Teiu,");
        doc.text(17, 32, "HUNEDOARA ROMANIA");
        // FIRST ROW // RIGHT
        doc.setFontSize(12);
        doc.text(112, 20, "INTERNATIONAL CONSIGNMENT NOTE");
        doc.setFontSize(16);
        doc.text(112, 30, "CMR");
        doc.setFontSize(8);
        doc.text(
          130,
          27,
          "This carriage is subject notwithstanding any clause to the\ncontrary, to the Convention on the Contract for the\nInternational Carriage of goods by road (CMR)"
        );
        doc.line(10, 40, 200, 40); // END FIRST ROW
        // SECOND ROW // LEFT
        doc.setFontSize(16);
        doc.text(12, 45, "2.");
        doc.setFontSize(6);
        doc.text(17, 45, "Consignee (name, address, country)");
        doc.setFontSize(8);
        //25 à 17
        doc.text(17, 50 + 0 * 8, stop[1]);
        doc.text(17, 53 + 0 * 8, stop[0]);

        // SECOND ROW // RIGHT
        doc.setFontSize(16);
        doc.text(107, 45, "16.");
        doc.setFontSize(6);
        doc.text(116, 45, "Carrier (name, address, country)");
        doc.setFontSize(8);

        // TRANSPORTEUR
        if (this.user_data.people[0].iscompany) {
          if (this.user_data.people[0].vat_number)
            doc.text(
              116,
              50,
              this.user_data.people[0].company_name +
              "(" +
              this.user_data.people[0].vat_number +
              ")"
            );
          else doc.text(116, 50, this.user_data.people[0].company_name);
        } else
          doc.text(
            116,
            50,
            this.user_data.people[0].firstname +
            " " +
            this.user_data.people[0].lastname
          );
        if (this.user_data.people[0].addresses[0]) {
          drawAddressBlock(doc, fromPersonAddress(this.user_data.people[0].addresses[0]), 116, 54, 4);
        } else doc.text(116, 54, "Address: NO DATA");
        doc.line(10, 70, 200, 70); // END SECOND ROW
        // THIRD ROW // LEFT
        doc.setFontSize(16);
        doc.text(12, 75, "3.");
        doc.setFontSize(6);
        doc.text(17, 75, "Place of delivery of the goods (place, country)");
        doc.setFontSize(8);

        doc.text(17, 80 + 0 * 4, stop[0]);

        const cmrGps = this.gpsSuffix(
          this.routetransport[i].latitude,
          this.routetransport[i].longitude
        );
        if (cmrGps) doc.text(17, 80 + 3, cmrGps.trim());
        doc.setFontSize(16);
        doc.text(107, 75, "17.");
        doc.setFontSize(6);
        doc.text(116, 75, "Successive Carriers (name, address, country)");
        doc.setFontSize(8);
        doc.line(10, 95, 200, 95); // END THRID ROW
        // FOURTH ROW // LEFT
        doc.setFontSize(16);
        doc.text(12, 100, "4.");
        doc.setFontSize(6);
        doc.text(
          17,
          100,
          "Place of and date of taking over the goods (place, country, date)"
        );
        doc.setFontSize(8);
        doc.text(17, 105, "DC 137, 337284 SAT TEIU,");
        doc.text(17, 109, "LAPUGIU DE JOS, HUNDEDOARA, ROMANIA");
        doc.text(17, 113, moment(this.user_data.date).format("DD/MM/YYYY"));
        // FOURTH ROW // RIGHT
        doc.setFontSize(16);
        doc.text(107, 100, "18.");
        doc.setFontSize(6);
        doc.text(116, 100, "Carrier's reservations and observations");
        doc.setFontSize(8);
        doc.text(116, 105, "Carrier's name: " + this.user_data.driver);
        doc.text(116, 109, "Carrier's phone: " + this.user_data.driver_phone);
        doc.text(116, 113, "Truck plate: " + this.user_data.truck_plate);
        doc.text(116, 117, "Trailer plate: " + this.user_data.trailer_plate);

        doc.line(10, 120, 105, 120); // END FOURTH ROW

        // FIFTH ROW LEFT
        doc.setFontSize(16);
        doc.text(12, 125, "5.");
        doc.setFontSize(6);
        doc.text(17, 125, "Documents attached");
        doc.setFontSize(8);
        doc.text(
          17,
          129,
          "Aviz de insotire a marfii:    Seria " +
          this.routetransport[i].aviz_serie +
          "   Nr." +
          this.routetransport[i].aviz_number
        );
        doc.setFontSize(6);
        doc.setFontSize(8);
        doc.line(10, 135, 200, 135); // horizon middle
        // SIXTH ROW LEFT
        doc.setFontSize(14);
        doc.text(12, 140, "6.");
        doc.setFontSize(6);
        doc.text(17, 140, "Marks and Nos");
        doc.setFontSize(14);
        doc.text(32, 140, "7.");
        doc.setFontSize(6);
        doc.text(37, 140, "Number of packages");
        doc.setFontSize(14);
        doc.text(62, 140, "8.");
        doc.setFontSize(6);
        doc.text(67, 140, "Method of packaging");
        doc.setFontSize(14);
        doc.text(92, 140, "9.");
        doc.setFontSize(6);
        doc.text(97, 140, "Nature of the goods");
        doc.setFontSize(14);
        doc.text(122, 140, "10.");
        doc.setFontSize(6);
        doc.text(129, 140, "Statistical number");
        doc.setFontSize(14);
        doc.text(147, 140, "11.");
        doc.setFontSize(6);
        doc.text(154, 140, "Gross weight in kg");
        doc.setFontSize(14);
        doc.text(177, 140, "12.");
        doc.setFontSize(6);

        doc.setFontSize(8);
        let z = 0;

        let sumQuantity = 0;
        let sumVolume = 0;

        let brutWeight = 0;
        let netWeight = 0;
        this.groupedProducts.forEach((value, index) => {
          if (value.id === this.routetransport[i].id) {
            if (value.category != "Services") {
              z++;

              // SI NORMAL changer category_language_client en category
              doc.text(17, 142 + z * 5, value.category_language_client);
              if (value.volume) doc.text(120, 142 + z * 5, value.quantity + " " + value.uom + " (" + value.volume + " m3)");
              else doc.text(120, 142 + z * 5, value.quantity + " " + value.uom);
              //doc.text(37, 150 + index * 8, value.quantity + " " + value.uom);
              let vl = value.category_language_client.split("(");
              //doc.text(97, 142 + z * 5, vl[0]);
              sumQuantity = sumQuantity + parseFloat(value.quantity);
              sumVolume = sumVolume + parseFloat(value.volume);
              //if (value.volume) doc.text(140, 142 + z * 5, value.volume+" m3");
              // doc.text(178, 142 + z * 5, value.volume + " m3");
              brutWeight = value.etransport_weight_brut
              netWeight = value.etransport_weight_net
            }
          }
        });

        if (brutWeight && netWeight) {
          doc.text(
            150,
            142 + 1 * 5,
            "Total Bruta: " + parseFloat(brutWeight).toFixed(0) + " kg"
          );
        }
        if (this.user_data.etransport_weight_net) {
          doc.text(
            150,
            147 + 1 * 5,
            "Total Neta: " + parseFloat(netWeight).toFixed(0) + " kg"
          );
        }
        if (sumVolume) {
          doc.text(
            180,
            142 + 1 * 5,
            "Total: " + parseFloat(sumVolume).toFixed(2) + " m3"
          );
        }
        else {
          doc.text(
            180,
            142 + 1 * 5,
            "Total:          m3"
          );
        }
        doc.line(10, 190, 200, 190); // horizon middle
        // SEV ROW // LEFT
        doc.setFontSize(16);
        doc.text(12, 195, "13.");
        doc.setFontSize(6);
        doc.text(21, 195, "Sender Instruction");
        doc.setFontSize(8);
        doc.text(21, 199, "Unloading Contact:");

        doc.text(21, 203, "Ferdinand Terlinden +32 473 233 33");
        doc.text(21, 207, stop[1]);

        // SEV ROW // RIGHT
        doc.setFontSize(16);
        doc.text(107, 195, "19.");
        doc.setFontSize(6);
        doc.text(116, 195, "Special Agreements");

        doc.setFontSize(12);
        if (this.routetransport[i].etransport_uit) doc.text(116, 205, "COD UIT:" + this.routetransport[i].etransport_uit);
        doc.line(10, 220, 200, 220); // END SEV ROW
        doc.setFontSize(16);
        doc.text(12, 225, "14.");
        doc.setFontSize(6);
        doc.text(21, 225, "Instructions as to payment for carriage");
        doc.setFontSize(8);
        doc.text(25, 230, "[] Carrage paid        [] Carrage forward");
        // 8 ROW // LEFT
        doc.line(10, 235, 200, 235); // END SEV ROW
        doc.setFontSize(16);
        doc.text(12, 240, "21.");
        doc.setFontSize(6);
        doc.text(21, 240, "Established in");
        doc.setFontSize(8);
        doc.text(
          25,
          245,
          "TEIU, ROMANIA   " +
          moment(this.user_data.date).format("DD MMMM YYYY")
        );
        // 8 ROW // RIGHT
        doc.setFontSize(16);
        doc.text(107, 225, "20.");
        doc.setFontSize(6);
        doc.text(
          116,
          225,
          "To be paid by (Carriage charges, deductions, balance, sup. charges, other charges)"
        );
        doc.line(105, 190, 105, 250); // vertical middle
        doc.line(10, 250, 200, 250); // END 8 ROW
        doc.setFontSize(16);
        doc.text(107, 240, "15.");
        doc.setFontSize(6);
        doc.text(116, 240, "Cash on delivery");
        // 9 ROW // LEFT
        doc.setFontSize(16);
        doc.text(12, 255, "22.");
        doc.setFontSize(6);
        doc.text(21, 255, "Signature and stamp of the sender");
        doc.line(70, 250, 70, 285); // vertical middle
        // 9 ROW // MID
        doc.setFontSize(16);
        doc.text(72, 255, "23.");
        doc.setFontSize(6);
        doc.text(81, 255, "Signature and stamp of the carrier");
        doc.line(140, 250, 140, 285); // vertical middle
        // 9 ROW // RIGHT
        doc.setFontSize(16);
        doc.text(142, 255, "24.");
        doc.setFontSize(6);
        doc.text(151, 255, "Signature and stamp of the consignee");
        doc.line(105, 190, 105, 250); // vertical middle
      }

      doc.save(
        +moment(this.user_data.date).format("YYYYMMDD") +
        "_CMR_" +
        this.user_data.operationcategory.name_en +
        "_" +
        this.user_data.id +
        ".pdf"
      );
    },
    ViewCompany() {
      window.location.replace("/person/" + this.user_data.Company.id);
    },
    getActiveColors(status) {
      if (status === true) return "primary";
      if (status === false) return "danger";
      return "warning";
    },
    async fetch_invoice_linked_data(userId) {
      if (userId) {
        this.$store
          .dispatch("operationList/fetchInvoiceLinked", userId)
          .then((res) => {
            this.invoiceattached = res.data;
            this.markers = res.data;
            this.generatedTimeline()
          });
      } else {
        this.invoiceattached = {};
      }
    },
  },
  created() {
    // Register Module UserManagement Module
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule("operationList", moduleOperationList);
      moduleOperationList.isRegistered = true;
    }
    const userId = this.$route.params.userId;
    this.fetch_invoice_linked_data(userId);
    this.getProductListPdf();
    this.$store
      .dispatch("operationList/fetchOperation", userId)
      .then((res) => {
        this.user_data = res.data;
        this.getDocument();
        this.updateDeliveryDate();
        this.getRouteTransport();
        this.getRouteTransportFromQuotation();
        this.getCMRproduct();
        this.getDuplicateCheck();
        this.getBillingAndDeliveryAddressListDetails();
        this.needSumalOrNot();
        this.sumalForceOrNot();
        this.getLog();

        if (this.user_data.operationcategory.id === 7) {
          this.$store
            .dispatch(
              "operationList/fetcheurdifference",
              this.$route.params.userId
            )
            .then((res) => {
            })
            .catch((err) => {
              if (err.response.status === 404) {
                this.user_not_found = true;
                return;
              }
              console.error(err);
            });
        } else {
          this.$router.push({ path: "/pages/error-404" });
        }
      })
      .catch((err) => {
        if (err.response.status === 404) {
          this.user_not_found = true;
          return;
        }
        console.error(err);
      });
  },
  beforeDestroy() {
    // Quitter la page pendant une generation laisserait tourner le filet de
    // securite, et l'overlay de chargement sur l'ecran suivant.
    this.stopInvoiceDownload();
  },
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}
</style>
